import { Icon, notification, Row, Col } from "antd";
import React, { Fragment } from "react";
import { AssignIcon } from "../../common/CustomIcon";
import { randomNumber } from "../../common/Common";


import MapRecoveryIcon from "../../../assets/images/MapPinRecovery.svg"
import MapPickupIcon from "../../../assets/images/MapPinPickup.svg"
import MapDeliveryIcon from "../../../assets/images/MapPinDelivery.svg"
import MapCrossdockIcon from "../../../assets/images/MapPinCrossdock.svg"
import MapCrossdockDeliveryIcon from "../../../assets/images/MapPinCrossDockDelivery.svg"
import MapPickupCrossdockIcon from "../../../assets/images/MapPinPickupCrossdock.svg"
import MapOutboundIcon from "../../../assets/images/MapPinOutbound.svg"
import MapInboundIcon from "../../../assets/images/MapPinInBound.svg"
import MapOutboundTransfer from "../../../assets/images/MapPinOutboundTransfer.svg"
import LinehaulTransfer from "../../../assets/images/LinehaulTransfer.svg"
import PickupLinehaul from "../../../assets/images/PickupLinehaul.svg"
import LinehaulDelivery from "../../../assets/images/LinehaulDelivery.svg"
import Linehaul from "../../../assets/images/Linehaul.svg"
import I18n from "../../common/I18n";


// SVG content
const CrossDockDeliveryIcon = ({
  width = "56",
  height = "56",
  color1 = "#2CCE9580",
  color2 = "#2CCE95",
  color3 = "#1D2540",
}) => (
  <svg
    viewBox="0 0 56 56"
    focusable="false"
    data-icon="assign"
    width={width}
    height={height}
    // fill={color}
    aria-hidden="true"
  >
    <path
      d="M49.5493 40.4792C49.2261 40.8315 48.6766 40.8315 48.3535 40.4792C47.3198 39.351 45.1626 36.9372 43.6343 34.8115C42.5843 33.352 41.98 32.1282 41.9356 30.538C41.8411 27.2083 44.178 24.1657 47.4388 23.4843C51.976 22.537 55.9718 25.974 55.9718 30.3455C55.9718 32.0313 55.3628 33.2937 54.2708 34.8127C52.7401 36.9372 50.583 39.351 49.5493 40.4792Z"
      fill={color1}
    />
    <path
      d="M43.7312 27.4371C45.0199 27.4371 46.0645 26.3924 46.0645 25.1038C46.0645 23.8151 45.0199 22.7704 43.7312 22.7704C42.4425 22.7704 41.3979 23.8151 41.3979 25.1038C41.3979 26.3924 42.4425 27.4371 43.7312 27.4371Z"
      fill={color3}
    />
    <path
      d="M42.2853 18.084C42.2853 17.1175 43.0688 16.334 44.0353 16.334C48.0591 16.334 50.7266 18.758 51.974 21.52C52.5911 22.8865 52.8845 24.3731 52.8391 25.7698C52.7942 27.1497 52.411 28.572 51.5268 29.6772C49.6557 32.0161 46.6576 35.715 45.3935 37.2709C45.0625 37.6783 44.566 37.9156 44.0411 37.9173C43.5161 37.919 43.0181 37.685 42.6844 37.2798C41.3246 35.6286 38.1793 31.7803 36.5289 29.6584C34.3857 26.9028 34.5861 23.4229 36.5659 21.047C37.1846 20.3045 38.2881 20.2042 39.0306 20.8229C39.7731 21.4417 39.8734 22.5451 39.2547 23.2876C38.318 24.4118 38.1682 26.0651 39.2917 27.5096C40.4885 29.0484 42.5076 31.5383 44.0281 33.3988C45.4788 31.6087 47.4362 29.1877 48.7938 27.4908C49.0763 27.1377 49.3129 26.5182 49.3409 25.656C49.3684 24.8105 49.1878 23.8544 48.7842 22.9605C47.9898 21.2016 46.4281 19.834 44.0353 19.834C43.0688 19.834 42.2853 19.0505 42.2853 18.084Z"
      fill={color3}
    />
    <path
      d="M29.1666 37.474V47.694C29.1666 50.354 27.0083 52.5007 24.3599 52.5007H17.6399C14.9916 52.5007 12.8333 50.3423 12.8333 47.694V17.6407C12.8333 14.9807 14.9916 12.834 17.6399 12.834H24.3599C27.0199 12.834 29.1666 14.9923 29.1666 17.6407V27.8607V37.474Z"
      fill={color2}
    />
    <path
      d="M13.4167 10.5C11.8048 10.5 10.5 11.8048 10.5 13.4167V32.6667C10.5 33.6332 9.7165 34.4167 8.75 34.4167C7.7835 34.4167 7 33.6332 7 32.6667V13.4167C7 9.87184 9.87183 7 13.4167 7H18.0833C21.6282 7 24.5 9.87184 24.5 13.4167V22.47C24.5 23.4365 23.7165 24.22 22.75 24.22C21.7835 24.22 21 23.4365 21 22.47V13.4167C21 11.8048 19.6952 10.5 18.0833 10.5H13.4167Z"
      fill={color3}
    />
    <path
      d="M22.75 30.916C23.7165 30.916 24.5 31.6995 24.5 32.666V42.5827C24.5 46.1275 21.6282 48.9993 18.0833 48.9993H13.4167C9.87183 48.9993 7 46.1275 7 42.5827V39.8177C7 38.8512 7.7835 38.0677 8.75 38.0677C9.7165 38.0677 10.5 38.8512 10.5 39.8177V42.5827C10.5 44.1945 11.8048 45.4993 13.4167 45.4993H18.0833C19.6952 45.4993 21 44.1945 21 42.5827V32.666C21 31.6995 21.7835 30.916 22.75 30.916Z"
      fill={color3}
    />
    <path
      d="M15.75 28C15.75 27.0335 16.5335 26.25 17.5 26.25H30.3333C31.2998 26.25 32.0833 27.0335 32.0833 28C32.0833 28.9665 31.2998 29.75 30.3333 29.75H17.5C16.5335 29.75 15.75 28.9665 15.75 28Z"
      fill={color3}
    />
    <path
      d="M26.1793 22.0965C26.8627 21.4131 27.9708 21.4131 28.6542 22.0965L33.3209 26.7632C34.0043 27.4466 34.0043 28.5547 33.3209 29.2381L28.6542 33.9048C27.9708 34.5882 26.8627 34.5882 26.1793 33.9048C25.4959 33.2213 25.4959 32.1133 26.1793 31.4299L29.6085 28.0007L26.1793 24.5714C25.4959 23.888 25.4959 22.78 26.1793 22.0965Z"
      fill={color3}
    />
    <path
      d="M17.5 31.5C19.433 31.5 21 29.933 21 28C21 26.067 19.433 24.5 17.5 24.5C15.567 24.5 14 26.067 14 28C14 29.933 15.567 31.5 17.5 31.5Z"
      fill={color3}
    />
  </svg>
);

// SVG content
const CrossDockIcon = ({ width = "56", height = "56", color = "#1A354D" }) => (
  <svg viewBox="0 0 24 24" focusable="false" data-icon="assign" width={width} height={height} fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path transform="translate(6.5 5.5)" d="M15 10.56V14.94C15 16.08 14.075 17 12.94 17H2.06C0.925 17 0 16.075 0 14.94V2.06C0 0.92 0.925 0 2.06 0H12.94C14.08 0 15 0.925 15 2.06V6.44V10.56Z" fill="#AABDCD" />
    <path transform="translate(3.75 3)" d="M15.75 10.25C16.1642 10.25 16.5 10.5858 16.5 11V15.25C16.5 16.7692 15.2692 18 13.75 18H2.75C1.23079 18 0 16.7692 0 15.25V14.0654C0 13.6512 0.335786 13.3154 0.75 13.3154C1.16421 13.3154 1.5 13.6512 1.5 14.0654V15.25C1.5 15.9408 2.05921 16.5 2.75 16.5H13.75C14.4408 16.5 15 15.9408 15 15.25V11C15 10.5858 15.3358 10.25 15.75 10.25ZM13.75 0C15.2692 0 16.5 1.23079 16.5 2.75V6.62988C16.5 7.0441 16.1642 7.37988 15.75 7.37988C15.3358 7.37988 15 7.0441 15 6.62988V2.75C15 2.05921 14.4408 1.5 13.75 1.5H2.75C2.05921 1.5 1.5 2.05921 1.5 2.75V11C1.5 11.4142 1.16421 11.75 0.75 11.75C0.335786 11.75 0 11.4142 0 11V2.75C0 1.23079 1.23079 0 2.75 0H13.75Z" fill={color} />
    <path transform="translate(9.25 7)" d="M2.74994 0C3.16416 1.81059e-08 3.49994 0.335786 3.49994 0.75V6.18945L4.21967 5.46973C4.51256 5.17683 4.98732 5.17683 5.28022 5.46973C5.57311 5.76262 5.57311 6.23738 5.28022 6.53027L3.28022 8.53027C2.98732 8.82317 2.51256 8.82317 2.21967 8.53027L0.21967 6.53027C-0.0732232 6.23738 -0.0732232 5.76262 0.21967 5.46973C0.512563 5.17683 0.987323 5.17683 1.28022 5.46973L1.99994 6.18945V0.75C1.99994 0.335786 2.33573 -1.81058e-08 2.74994 0Z" fill={color} />
  </svg>
);

const WarehouseStorageIcon = ({
  width = "56",
  height = "56",
  color1 = "#AABDCD", // Primary fill
  color2 = "#1D2540", // Path/Stroke color
  color3 = "#D5DEEB"  // Extra color (if needed for future layers)
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect x="6" y="7" width="16" height="14" rx="1" fill={color1} />

    <path
      d="M13.75 7.5C14.7167 7.5 15.5 8.28329 15.5 9.25V12.5H16.25C17.2167 12.5 18 13.2833 18 14.25V16.4785C18 16.8927 17.6642 17.2285 17.25 17.2285C16.8358 17.2285 16.5 16.8927 16.5 16.4785V14.25C16.5 14.1117 16.3883 14 16.25 14H15.3779V14.75C15.3779 15.1641 15.0419 15.4998 14.6279 15.5C14.2137 15.5 13.8779 15.1642 13.8779 14.75V14H12.75V17.9941H19.25C19.3882 17.9941 19.4999 17.8824 19.5 17.7441V16.5215C19.5 16.1073 19.8358 15.7715 20.25 15.7715C20.6642 15.7715 21 16.1073 21 16.5215V17.7441C20.9999 18.7108 20.2167 19.4941 19.25 19.4941H6.83984C6.81037 19.4977 6.78043 19.5 6.75 19.5C6.71957 19.5 6.68963 19.4977 6.66016 19.4941H4.75C3.78333 19.4941 3.00006 18.7108 3 17.7441V12.8613C3.00011 12.4472 3.33585 12.1113 3.75 12.1113C4.16415 12.1113 4.49989 12.4472 4.5 12.8613V17.7441C4.50006 17.8824 4.61175 17.9941 4.75 17.9941H6V14.25C6.00001 13.2833 6.78329 12.5 7.75 12.5H14V9.25C14 9.11172 13.8883 9 13.75 9H12.75V9.75C12.75 10.1642 12.4142 10.5 12 10.5C11.5858 10.5 11.25 10.1642 11.25 9.75V9H10.25C10.1117 9 10 9.11172 10 9.25V10.75C10 11.1642 9.66421 11.5 9.25 11.5C8.83579 11.5 8.5 11.1642 8.5 10.75V9.25C8.5 8.28329 9.28329 7.5 10.25 7.5H13.75ZM7.75 14C7.61172 14 7.5 14.1117 7.5 14.25V17.9941H11.25V14H10.1279V14.75C10.1279 15.1641 9.79195 15.4998 9.37793 15.5C8.96372 15.5 8.62793 15.1642 8.62793 14.75V14H7.75ZM19.25 4C20.2167 4 21 4.78329 21 5.75V10.6328C20.9998 11.0469 20.6641 11.3828 20.25 11.3828C19.8359 11.3828 19.5002 11.0469 19.5 10.6328V5.75C19.5 5.61171 19.3883 5.5 19.25 5.5H4.75C4.61171 5.5 4.5 5.61171 4.5 5.75V6.97266C4.49992 7.3868 4.16416 7.72266 3.75 7.72266C3.33584 7.72266 3.00008 7.3868 3 6.97266V5.75C3 4.78329 3.78329 4 4.75 4H19.25Z"
      fill={color2}
    />
  </svg>
);

export default WarehouseStorageIcon;

const CrossDockIconPickupIcon = ({ width = "56", height = "56", color = "#1A354D" }) => (
  <svg viewBox="0 0 24 24" focusable="false" data-icon="assign" width={width} height={height} fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path transform="translate(6.5 5.5)" d="M15 10.56V14.94C15 16.08 14.075 17 12.94 17H2.06C0.925 17 0 16.075 0 14.94V2.06C0 0.92 0.925 0 2.06 0H12.94C14.08 0 15 0.925 15 2.06V6.44V10.56Z" fill="#C8D8E4" />
    <path transform="translate(3.75 3)" d="M15.75 10.25C16.1642 10.25 16.5 10.5858 16.5 11V15.25C16.5 16.7692 15.2692 18 13.75 18H2.75C1.23079 18 0 16.7692 0 15.25V14.0654C0 13.6512 0.335786 13.3154 0.75 13.3154C1.16421 13.3154 1.5 13.6512 1.5 14.0654V15.25C1.5 15.9408 2.05921 16.5 2.75 16.5H13.75C14.4408 16.5 15 15.9408 15 15.25V11C15 10.5858 15.3358 10.25 15.75 10.25ZM13.75 0C15.2692 0 16.5 1.23079 16.5 2.75V6.62988C16.5 7.0441 16.1642 7.37988 15.75 7.37988C15.3358 7.37988 15 7.0441 15 6.62988V2.75C15 2.05921 14.4408 1.5 13.75 1.5H2.75C2.05921 1.5 1.5 2.05921 1.5 2.75V11C1.5 11.4142 1.16421 11.75 0.75 11.75C0.335786 11.75 0 11.4142 0 11V2.75C0 1.23079 1.23079 0 2.75 0H13.75Z" fill={color} />
    <path transform="translate(14.75 15.75) rotate(180)" d="M2.74994 0C3.16416 1.81059e-08 3.49994 0.335786 3.49994 0.75V6.18945L4.21967 5.46973C4.51256 5.17683 4.98732 5.17683 5.28022 5.46973C5.57311 5.76262 5.57311 6.23738 5.28022 6.53027L3.28022 8.53027C2.98732 8.82317 2.51256 8.82317 2.21967 8.53027L0.21967 6.53027C-0.0732232 6.23738 -0.0732232 5.76262 0.21967 5.46973C0.512563 5.17683 0.987323 5.17683 1.28022 5.46973L1.99994 6.18945V0.75C1.99994 0.335786 2.33573 -1.81058e-08 2.74994 0Z" fill={color} />
  </svg>
);

// SVG content
const DeliveryIcon = ({ width = "56", height = "56", color = "#1A354D" }) => (
  <svg
    viewBox="0 0 24 24"
    focusable="false"
    data-icon="assign"
    width={width}
    height={height}
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      transform="translate(6.5 5.05)"
      d="M15 7.5C15 3.35 11.65 0 7.5 0C3.35 0 0 3.35 0 7.5C0 9.35 0.7 11.05 1.8 12.35C1.8 12.35 5.35 16.4 6.5 17.5C7.05 18.05 7.95 18.05 8.5 17.5C9.85 16.25 13.2 12.35 13.2 12.35C14.3 11.05 15 9.35 15 7.5Z"
      fill="#34D399"
    />
    <path
      transform="translate(3.5 1.95)"
      d="M0.75 7.5498C1.16415 7.5498 1.4999 7.88568 1.5 8.2998V8.5498C1.5 10.2562 2.12666 11.8376 3.17188 13.1143L3.2041 13.1514C3.23134 13.1822 3.27171 13.2278 3.32324 13.2861C3.42633 13.4027 3.57496 13.5705 3.75684 13.7754C4.12094 14.1855 4.61845 14.7438 5.15137 15.3359C6.22286 16.5265 7.40894 17.8214 7.96191 18.3516C8.28773 18.6457 8.72593 18.6137 8.96973 18.3701C8.98923 18.3506 9.00971 18.3317 9.03125 18.3145C9.21302 18.169 9.4606 17.8847 9.78027 17.5117C10.0498 17.1972 10.5234 17.1612 10.8379 17.4307C11.1523 17.7002 11.1894 18.1738 10.9199 18.4883C10.9094 18.5006 10.8984 18.5129 10.8877 18.5254C10.6224 18.8351 10.2976 19.2138 10 19.46C9.1436 20.2843 7.8067 20.2443 6.94336 19.4531C6.93953 19.4496 6.9354 19.446 6.93164 19.4424C6.33175 18.8686 5.09781 17.5185 4.03613 16.3389C3.50039 15.7436 3.00029 15.1832 2.63477 14.7715C2.45201 14.5656 2.30292 14.3966 2.19922 14.2793C2.14738 14.2207 2.10661 14.1747 2.0791 14.1436L2.03711 14.0957C2.03146 14.0893 2.02593 14.0828 2.02051 14.0762C0.770576 12.5545 0 10.639 0 8.5498V8.2998C9.89401e-05 7.88568 0.335847 7.5498 0.75 7.5498ZM8.5 0C13.2142 0 17 3.78579 17 8.5C17 10.6346 16.2321 12.5553 14.9707 14.0361L14.9648 14.0439L14.9473 14.0635C14.9364 14.0758 14.9208 14.094 14.9004 14.1172C14.8591 14.164 14.7984 14.2322 14.7227 14.3174C14.5712 14.4878 14.3575 14.7277 14.1055 15.0049C13.8269 15.3114 13.3524 15.3333 13.0459 15.0547C12.7394 14.7761 12.7165 14.3016 12.9951 13.9951C13.2427 13.7227 13.4531 13.4873 13.6016 13.3203C13.6758 13.2368 13.7354 13.1704 13.7754 13.125C13.7891 13.1095 13.8004 13.0963 13.8096 13.0859C13.8135 13.0814 13.8172 13.0767 13.8203 13.0732L13.832 13.0596C14.8687 11.8409 15.5 10.2636 15.5 8.5C15.5 4.61421 12.3858 1.5 8.5 1.5C6.77849 1.50001 5.2506 2.08655 4.03613 3.12109C3.72083 3.38946 3.24803 3.35132 2.97949 3.03613C2.71099 2.72093 2.74848 2.24815 3.06348 1.97949C4.54898 0.714062 6.42156 1.45162e-05 8.5 0ZM8.5 4.2998C8.91415 4.2998 9.2499 4.63568 9.25 5.0498V9.73926L10.4697 8.51953C10.7626 8.22676 11.2374 8.22676 11.5303 8.51953C11.8231 8.81239 11.8231 9.28718 11.5303 9.58008L9.03027 12.0801C8.73738 12.373 8.26262 12.373 7.96973 12.0801L5.46973 9.58008C5.17693 9.28718 5.17686 8.81239 5.46973 8.51953C5.7626 8.22676 6.2374 8.22676 6.53027 8.51953L7.75 9.73926V5.0498C7.7501 4.63568 8.08585 4.2998 8.5 4.2998Z"
      fill={color}
    />
  </svg>
);

const LineHaulIcon = ({
  width = "56",
  height = "56",
  color1 = "#FFBA07",
  color2 = "#1D2540",
}) => (
  <svg
    viewBox="0 0 56 56"
    focusable="false"
    data-icon="multi-stop-order-type"
    width={width}
    height={height}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M48.9999 27.4442V45.0258C48.9999 47.2203 47.2196 49.0006 45.0239 49.0006H20.3093C18.1136 49.0006 16.3333 47.2203 16.3333 45.0246V42.5665V34.6262V20.31C16.3333 18.1143 18.1136 16.334 20.3093 16.334H45.0239C47.2196 16.334 48.9999 18.1143 48.9999 20.31V21.9048V27.4442Z"
        fill={color1}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8334 15.2198C12.8334 13.902 13.9014 12.834 15.2192 12.834H40.7797C42.0976 12.834 43.1656 13.902 43.1656 15.2198V16.8532C43.1656 17.8196 43.9491 18.6032 44.9156 18.6032C45.8821 18.6032 46.6656 17.8196 46.6656 16.8532V15.2198C46.6656 11.969 44.0306 9.33398 40.7797 9.33398H15.2192C11.9684 9.33398 9.33341 11.969 9.33341 15.2198V27.8992C9.33341 28.8657 10.1169 29.6492 11.0834 29.6492C12.0499 29.6492 12.8334 28.8657 12.8334 27.8992V15.2198ZM50.0253 24.5007H46.6667V40.7815C46.6667 44.0323 44.0317 46.6673 40.7809 46.6673H15.2192C11.9684 46.6673 9.33341 44.0323 9.33341 40.7815V37.334H5.9761L6.03249 37.3904C6.71591 38.0738 6.71591 39.1818 6.03249 39.8652C5.34907 40.5487 4.24103 40.5487 3.55762 39.8652L0.513784 36.8214C0.185595 36.4932 0.00122056 36.0481 0.0012207 35.584C0.00122084 35.1198 0.185595 34.6747 0.513784 34.3465L3.55762 31.3027C4.24104 30.6193 5.34907 30.6193 6.03249 31.3027C6.71591 31.9861 6.71591 33.0942 6.03249 33.7776L5.97609 33.834H18.0834C19.0499 33.834 19.8334 34.6175 19.8334 35.584C19.8334 36.5505 19.0499 37.334 18.0834 37.334H12.8334V40.7815C12.8334 42.0993 13.9014 43.1673 15.2192 43.1673H40.7809C42.0988 43.1673 43.1667 42.0993 43.1667 40.7815V24.5007H37.9179C36.9514 24.5007 36.1679 23.7171 36.1679 22.7507C36.1679 21.7842 36.9514 21.0007 37.9179 21.0007H50.0253L49.9689 20.9442C49.2855 20.2608 49.2855 19.1528 49.9689 18.4694C50.6524 17.786 51.7604 17.786 52.4438 18.4694L55.4877 21.5132C55.8158 21.8414 56.0002 22.2865 56.0002 22.7506C56.0002 23.2148 55.8158 23.6599 55.4877 23.9881L52.4438 27.0319C51.7604 27.7153 50.6524 27.7153 49.9689 27.0319C49.2855 26.3485 49.2855 25.2405 49.9689 24.557L50.0253 24.5007Z"
        fill={color2}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MultiStopIcon = ({
  width = "56",
  height = "56",
  color1 = "#B38205",
  color2 = "#1D2540",
}) => (
  <svg
    viewBox="0 0 56 56"
    focusable="false"
    data-icon="assign"
    width={width}
    height={height}
    // fill={color}
    aria-hidden="true"
  >
    <path
      d="M46.6666 50.1673H18.6666C17.3774 50.1673 16.3333 49.1232 16.3333 47.834V18.6673C16.3333 17.3782 17.3774 16.334 18.6666 16.334H46.6666C47.9558 16.334 48.9999 17.3782 48.9999 18.6673V47.834C48.9999 49.1232 47.9558 50.1673 46.6666 50.1673Z"
      fill={color1}
    />
    <path
      d="M12.25 9.33398C11.2833 9.33398 10.5 10.1173 10.5 11.084C10.5 12.0505 9.7165 12.834 8.75 12.834C7.7835 12.834 7 12.0505 7 11.084C7 8.18432 9.35034 5.83398 12.25 5.83398C14.536 5.83398 16.4806 7.29482 17.2013 9.33398H43.75C46.6497 9.33398 49 11.6843 49 14.584V23.9173C49 26.817 46.6497 29.1673 43.75 29.1673H30.4749L32.7374 31.4299C33.4209 32.1133 33.4209 33.2213 32.7374 33.9048C32.054 34.5882 30.946 34.5882 30.2626 33.9048L25.0126 28.6548C24.3291 27.9713 24.3291 26.8633 25.0126 26.1799L30.2626 20.9299C30.946 20.2465 32.054 20.2465 32.7374 20.9299C33.4209 21.6133 33.4209 22.7213 32.7374 23.4048L30.4749 25.6673H43.75C44.7167 25.6673 45.5 24.884 45.5 23.9173V14.584C45.5 13.6173 44.7167 12.834 43.75 12.834H17.2013C16.4806 14.8731 14.536 16.334 12.25 16.334C11.2835 16.334 10.5 15.5505 10.5 14.584C10.5 13.6175 11.2835 12.834 12.25 12.834C13.2167 12.834 14 12.0507 14 11.084C14 10.1173 13.2167 9.33398 12.25 9.33398ZM43.75 43.1673C42.7833 43.1673 42 43.9507 42 44.9173C42 45.884 42.7833 46.6673 43.75 46.6673C44.7167 46.6673 45.5 45.884 45.5 44.9173C45.5 43.9508 46.2835 43.1673 47.25 43.1673C48.2165 43.1673 49 43.9508 49 44.9173C49 47.817 46.6497 50.1673 43.75 50.1673C41.464 50.1673 39.5194 48.7065 38.7987 46.6673H37.9167C36.9502 46.6673 36.1667 45.8838 36.1667 44.9173C36.1667 43.9508 36.9502 43.1673 37.9167 43.1673H38.7987C39.5194 41.1282 41.464 39.6673 43.75 39.6673C44.7165 39.6673 45.5 40.4508 45.5 41.4173C45.5 42.3838 44.7165 43.1673 43.75 43.1673ZM33.8333 44.9173C33.8333 45.8838 33.0498 46.6673 32.0833 46.6673C31.1168 46.6673 30.3333 45.8838 30.3333 44.9173C30.3333 43.9508 31.1168 43.1673 32.0833 43.1673C33.0498 43.1673 33.8333 43.9508 33.8333 44.9173ZM26.25 46.6673C27.2165 46.6673 28 45.8838 28 44.9173C28 43.9508 27.2165 43.1673 26.25 43.1673C25.2835 43.1673 24.5 43.9508 24.5 44.9173C24.5 45.8838 25.2835 46.6673 26.25 46.6673ZM22.1667 44.9173C22.1667 45.8838 21.3832 46.6673 20.4167 46.6673C19.4502 46.6673 18.6667 45.8838 18.6667 44.9173C18.6667 43.9508 19.4502 43.1673 20.4167 43.1673C21.3832 43.1673 22.1667 43.9508 22.1667 44.9173ZM14.5833 46.6673C15.5498 46.6673 16.3333 45.8838 16.3333 44.9173C16.3333 43.9508 15.5498 43.1673 14.5833 43.1673C13.6168 43.1673 12.8333 43.9508 12.8333 44.9173C12.8333 45.8838 13.6168 46.6673 14.5833 46.6673ZM10.5 44.9173C10.5 45.8838 9.7165 46.6673 8.75 46.6673C7.7835 46.6673 7 45.8838 7 44.9173C7 43.9508 7.7835 43.1673 8.75 43.1673C9.7165 43.1673 10.5 43.9508 10.5 44.9173ZM8.75 40.834C9.7165 40.834 10.5 40.0505 10.5 39.084C10.5 38.1175 9.7165 37.334 8.75 37.334C7.7835 37.334 7 38.1175 7 39.084C7 40.0505 7.7835 40.834 8.75 40.834ZM10.5 33.2507C10.5 34.2171 9.7165 35.0007 8.75 35.0007C7.7835 35.0007 7 34.2171 7 33.2507C7 32.2842 7.7835 31.5007 8.75 31.5007C9.7165 31.5007 10.5 32.2842 10.5 33.2507ZM8.75 29.1673C9.7165 29.1673 10.5 28.3838 10.5 27.4173C10.5 26.4508 9.7165 25.6673 8.75 25.6673C7.7835 25.6673 7 26.4508 7 27.4173C7 28.3838 7.7835 29.1673 8.75 29.1673ZM16.3333 27.4173C16.3333 28.3838 15.5498 29.1673 14.5833 29.1673C13.6168 29.1673 12.8333 28.3838 12.8333 27.4173C12.8333 26.4508 13.6168 25.6673 14.5833 25.6673C15.5498 25.6673 16.3333 26.4508 16.3333 27.4173ZM20.4167 29.1673C21.3832 29.1673 22.1667 28.3838 22.1667 27.4173C22.1667 26.4508 21.3832 25.6673 20.4167 25.6673C19.4502 25.6673 18.6667 26.4508 18.6667 27.4173C18.6667 28.3838 19.4502 29.1673 20.4167 29.1673Z"
      fill={color2}
    />
  </svg>
);

const RadioActiveIcon = ({
  width = "16",
  height = "16",
  color1 = "#1D2540",
}) => (
  <svg
    viewBox="0 0 16 16"
    focusable="false"
    data-icon="assign"
    width={width}
    height={height}
    // fill={color}
    aria-hidden="true"
  >
    <path
      d="M5 2.66602C3.19866 3.704 2 5.68869 2 7.94048H5.85714C5.85714 7.16283 6.29576 6.47986 6.98214 6.04708L5 2.66602ZM11 2.66602L9.01786 6.04708C9.70424 6.47986 10.1429 7.16283 10.1429 7.94048H14C14 5.68869 12.8013 3.79191 11 2.66602ZM7.78571 6.83149C7.27679 6.9363 6.875 7.39613 6.875 7.94048C6.875 8.56259 7.38393 9.07652 8 9.07652C8.61607 9.07652 9.125 8.56259 9.125 7.94048C9.125 7.31836 8.61607 6.83149 8 6.83149C7.92299 6.83149 7.85938 6.81796 7.78571 6.83149ZM6.98214 9.86092L5 13.2149C5.85714 13.7356 6.88505 13.9993 8 13.9993C9.11496 13.9993 10.1429 13.7356 11 13.2149L9.01786 9.86092C8.76005 10.0334 8.42857 10.1044 8 10.1044C7.57143 10.1044 7.23996 10.0334 6.98214 9.86092Z"
      fill={color1}
    />
  </svg>
);

// SVG content
const OutboundTransferIcon = ({
  width = "56",
  height = "56",
  color1 = "#FE8C36",
  color2 = "#1D2540",
}) => (
  <svg
    viewBox="0 0 56 56"
    focusable="false"
    data-icon="assign"
    width={width}
    height={height}
    // fill={color}
    aria-hidden="true"
  >
    <path
      d="M50.1667 29.2832C50.1667 19.5999 42.3501 11.7832 32.6667 11.7832C22.9834 11.7832 15.1667 19.5999 15.1667 29.2832C15.1667 33.5999 16.8001 37.5665 19.3667 40.5999C19.3667 40.5999 27.6501 50.0499 30.3334 52.6165C31.6167 53.8999 33.7167 53.8999 35.0001 52.6165C38.1501 49.6999 45.9667 40.5999 45.9667 40.5999C48.5334 37.5665 50.1667 33.5999 50.1667 29.2832Z"
      fill={color1}
    />
    <path
      d="M28.0002 4.55078C23.1505 4.55078 18.7816 6.21591 15.3154 9.16861C14.5797 9.79535 14.4913 10.8999 15.1181 11.6356C15.7448 12.3713 16.8493 12.4597 17.585 11.833C20.4188 9.41899 23.9833 8.05078 28.0002 8.05078C37.0671 8.05078 44.3336 15.3173 44.3336 24.3841C44.3336 28.4991 42.8612 32.1801 40.4423 35.0237L40.4145 35.0554L40.3898 35.0835L40.3082 35.1762C40.2149 35.2821 40.078 35.437 39.9048 35.6319C39.5582 36.0218 39.0668 36.571 38.4887 37.2069C37.8385 37.9221 37.8912 39.0289 38.6064 39.679C39.3215 40.3292 40.4283 40.2764 41.0785 39.5613C41.667 38.9139 42.1672 38.3548 42.5207 37.9572C42.6975 37.7583 42.8376 37.5997 42.9339 37.4904L43.0445 37.3647L43.0839 37.3198L43.0991 37.3023C46.0424 33.8471 47.8336 29.3648 47.8336 24.3841C47.8336 13.3843 39.0001 4.55078 28.0002 4.55078ZM11.6667 23.9174C11.6667 22.9509 10.8832 22.1674 9.91675 22.1674C8.95025 22.1674 8.16675 22.9509 8.16675 23.9174V24.5008C8.16675 29.3755 9.96464 33.8443 12.8811 37.3949C12.8939 37.4104 12.907 37.4258 12.9203 37.4409L14.2334 36.2841C12.9203 37.4409 12.9207 37.4413 12.9207 37.4414L13.0188 37.5526L13.2985 37.8692C13.5405 38.143 13.8891 38.5368 14.3156 39.0173C15.1687 39.9781 16.3344 41.2864 17.5847 42.6756C20.062 45.4281 22.9407 48.5765 24.3404 49.9154L24.3601 49.9339L24.3676 49.9408C26.3822 51.7876 29.5025 51.8811 31.5009 49.9569C32.1953 49.3825 32.9513 48.4999 33.5704 47.7773L33.6454 47.6896C34.2744 46.9558 34.1895 45.851 33.4556 45.2221C32.7218 44.5931 31.617 44.6781 30.988 45.4119C30.2421 46.2821 29.6643 46.9449 29.2402 47.2842C29.1898 47.3246 29.1416 47.3677 29.096 47.4133C28.5272 47.9821 27.505 48.0581 26.7446 47.3717C25.4544 46.1346 22.6867 43.1125 20.1863 40.3342C18.9428 38.9526 17.7825 37.6505 16.933 36.6936C16.5082 36.2152 16.1614 35.8233 15.9208 35.5512L15.6432 35.2369L15.5668 35.1503C13.128 32.1715 11.6667 28.4825 11.6667 24.5008V23.9174ZM18.6667 23.9174C18.6667 22.9509 19.4502 22.1674 20.4167 22.1674H31.3585L28.5126 19.3215C27.8292 18.6381 27.8292 17.5301 28.5126 16.8467C29.1961 16.1632 30.3041 16.1632 30.9875 16.8467L36.8209 22.68C37.5043 23.3634 37.5043 24.4714 36.8209 25.1549L30.9875 30.9882C30.3041 31.6716 29.1961 31.6716 28.5126 30.9882C27.8292 30.3048 27.8292 29.1967 28.5126 28.5133L31.3585 25.6674H20.4167C19.4502 25.6674 18.6667 24.8839 18.6667 23.9174Z"
      fill={color2}
    />
  </svg>
);

const PickupIcon = ({ width = "56", height = "56", color = "#1A354D" }) => (
  <svg
    viewBox="0 0 24 24"
    focusable="false"
    data-icon="assign"
    width={width}
    height={height}
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      transform="translate(6.5 5.05)"
      d="M15 7.5C15 3.35 11.65 0 7.5 0C3.35 0 0 3.35 0 7.5C0 9.35 0.7 11.05 1.8 12.35C1.8 12.35 5.35 16.4 6.5 17.5C7.05 18.05 7.95 18.05 8.5 17.5C9.85 16.25 13.2 12.35 13.2 12.35C14.3 11.05 15 9.35 15 7.5Z"
      fill="#FF2D78"
    />
    <path
      transform="translate(3.5 1.95)"
      d="M0.75 7.5498C1.16415 7.5498 1.4999 7.88568 1.5 8.2998V8.5498C1.5 10.2562 2.12666 11.8376 3.17188 13.1143L3.2041 13.1514C3.23134 13.1822 3.27171 13.2278 3.32324 13.2861C3.42633 13.4027 3.57496 13.5705 3.75684 13.7754C4.12094 14.1855 4.61845 14.7438 5.15137 15.3359C6.22286 16.5265 7.40894 17.8214 7.96191 18.3516C8.28773 18.6457 8.72593 18.6137 8.96973 18.3701C8.98923 18.3506 9.00971 18.3317 9.03125 18.3145C9.21302 18.169 9.4606 17.8847 9.78027 17.5117C10.0498 17.1972 10.5234 17.1612 10.8379 17.4307C11.1523 17.7002 11.1894 18.1738 10.9199 18.4883C10.9094 18.5006 10.8984 18.5129 10.8877 18.5254C10.6224 18.8351 10.2976 19.2138 10 19.46C9.1436 20.2843 7.8067 20.2443 6.94336 19.4531C6.93953 19.4496 6.9354 19.446 6.93164 19.4424C6.33175 18.8686 5.09781 17.5185 4.03613 16.3389C3.50039 15.7436 3.00029 15.1832 2.63477 14.7715C2.45201 14.5656 2.30292 14.3966 2.19922 14.2793C2.14738 14.2207 2.10661 14.1747 2.0791 14.1436L2.03711 14.0957C2.03146 14.0893 2.02593 14.0828 2.02051 14.0762C0.770576 12.5545 0 10.639 0 8.5498V8.2998C9.89401e-05 7.88568 0.335847 7.5498 0.75 7.5498ZM8.5 0C13.2142 0 17 3.78579 17 8.5C17 10.6346 16.2321 12.5553 14.9707 14.0361L14.9648 14.0439L14.9473 14.0635C14.9364 14.0758 14.9208 14.094 14.9004 14.1172C14.8591 14.164 14.7984 14.2322 14.7227 14.3174C14.5712 14.4878 14.3575 14.7277 14.1055 15.0049C13.8269 15.3114 13.3524 15.3333 13.0459 15.0547C12.7394 14.7761 12.7165 14.3016 12.9951 13.9951C13.2427 13.7227 13.4531 13.4873 13.6016 13.3203C13.6758 13.2368 13.7354 13.1704 13.7754 13.125C13.7891 13.1095 13.8004 13.0963 13.8096 13.0859C13.8135 13.0814 13.8172 13.0767 13.8203 13.0732L13.832 13.0596C14.8687 11.8409 15.5 10.2636 15.5 8.5C15.5 4.61421 12.3858 1.5 8.5 1.5C6.77849 1.50001 5.2506 2.08655 4.03613 3.12109C3.72083 3.38946 3.24803 3.35132 2.97949 3.03613C2.71099 2.72093 2.74848 2.24815 3.06348 1.97949C4.54898 0.714062 6.42156 1.45162e-05 8.5 0ZM7.96973 4.51953C8.2626 4.22676 8.7374 4.22676 9.03027 4.51953L11.5303 7.01953C11.8231 7.31239 11.8231 7.78718 11.5303 8.08008C11.2374 8.37297 10.7626 8.37297 10.4697 8.08008L9.25 6.86035V11.5498C9.25 11.964 8.91421 12.2998 8.5 12.2998C8.08579 12.2998 7.75 11.964 7.75 11.5498V6.86035L6.53027 8.08008C6.23738 8.37297 5.76262 8.37297 5.46973 8.08008C5.17692 7.78718 5.17686 7.31239 5.46973 7.01953L7.96973 4.51953Z"
      fill={color}
    />
  </svg>
);

const OnSiteServiceIcon = ({ width = "56", height = "56", path1Color = "#AABDCD", path2Color = "#1D2540" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.2 8.79998C19.05 8.64998 18.95 8.44998 18.95 8.24998C18.95 8.04998 19.05 7.84998 19.2 7.69998L19.6 7.39998C19.7 7.29998 19.75 7.14998 19.7 6.99998C19.5 6.24998 19.1 5.59998 18.55 5.04998C18.45 4.94998 18.3 4.89998 18.15 4.94998L17.7 5.09998C17.5 5.19998 17.25 5.14998 17.1 5.04998C16.9 4.94998 16.8 4.74998 16.75 4.54998L16.65 4.04998C16.65 3.89998 16.5 3.79998 16.35 3.74998C15.6 3.54998 14.85 3.54998 14.1 3.74998C13.95 3.79998 13.85 3.89998 13.8 4.04998L13.7 4.54998C13.65 4.74998 13.55 4.94998 13.35 5.04998C13.15 5.14998 12.95 5.19998 12.75 5.09998L12.3 4.94998C12.15 4.89998 12 4.94998 11.9 5.04998C11.35 5.59998 11 6.24998 10.75 6.99998C10.7 7.14998 10.75 7.29998 10.85 7.39998L11.25 7.69998C11.4 7.84998 11.5 8.04998 11.5 8.24998C11.5 8.44998 11.4 8.64998 11.25 8.79998L10.85 9.09998C10.75 9.19998 10.7 9.34998 10.75 9.49998C10.95 10.25 11.35 10.9 11.9 11.45C12 11.55 12.15 11.6 12.3 11.55L12.75 11.4C12.95 11.3 13.2 11.35 13.35 11.45C13.55 11.55 13.65 11.75 13.7 11.95L13.8 12.45C13.8 12.6 13.95 12.7 14.1 12.75C14.5 12.85 14.85 12.9 15.25 12.9C15.65 12.9 16 12.85 16.4 12.75C16.55 12.7 16.65 12.6 16.7 12.45L16.8 11.95C16.85 11.75 16.95 11.55 17.15 11.45C17.35 11.35 17.55 11.3 17.75 11.4L18.2 11.55C18.35 11.6 18.5 11.55 18.6 11.45C19.15 10.9 19.5 10.25 19.75 9.49998C19.8 9.34998 19.75 9.19998 19.65 9.09998L19.2 8.79998Z"
      fill={path1Color}
    />
    <path
      d="M6.90039 12C7.84365 12 8.36169 12.1455 8.93066 12.2666C9.46835 12.381 10.154 12.5 11.5498 12.5H13.75C15.0367 12.5 16.0741 13.619 15.999 14.8945V14.8965C15.9202 16.157 14.7772 16.9998 13.6504 17H10.25C9.83579 17 9.5 16.6642 9.5 16.25C9.5 15.8358 9.83579 15.5 10.25 15.5H13.6504C14.122 15.4998 14.4782 15.1441 14.501 14.8057C14.5258 14.3814 14.1631 14 13.75 14H11.5498C10.0462 14 9.25635 13.869 8.61914 13.7334C8.01346 13.6045 7.65634 13.5 6.90039 13.5C5.91335 13.5 5.03796 13.9928 4.29492 14.6904C3.55365 15.3864 3.00962 16.2273 2.70312 16.7695L2.70117 16.7725C2.67925 16.8109 2.67048 16.8502 2.67383 16.9004C2.67718 16.9498 2.6934 17.0169 2.73438 17.0967L4.90527 20.0566L4.91406 20.0703C4.939 20.1058 5.00221 20.1517 5.10449 20.1582C5.20706 20.1646 5.26713 20.1262 5.28906 20.1016C5.79972 19.5271 6.59234 19 7.75 19C8.16418 19 8.5 19.3358 8.5 19.75C8.5 20.1642 8.16418 20.5 7.75 20.5C7.10769 20.5 6.6995 20.7731 6.41016 21.0986C6.03222 21.5236 5.49301 21.686 5.00879 21.6553C4.5285 21.6246 4.02088 21.3988 3.69531 20.9434L1.49512 17.9434C1.47841 17.9206 1.46325 17.8966 1.44922 17.8721C1.15771 17.3619 1.03191 16.6715 1.39941 16.0283C1.74332 15.4203 2.37294 14.4367 3.26758 13.5967C4.16197 12.7569 5.38759 12 6.90039 12ZM20.793 11.0684C21.3737 11.0582 21.9018 11.2915 22.3301 11.7197L22.4834 11.8799C23.1996 12.7087 23.1558 13.9364 22.4414 14.7598C22.4225 14.7841 22.4022 14.8078 22.3799 14.8301L22.3301 14.8799C22.2914 14.9186 22.2493 14.952 22.2051 14.9805C19.5814 17.1736 17.9045 18.6599 16.7451 19.5713C15.5793 20.4877 14.7333 21 13.75 21C12.9677 21 12.1363 20.9475 11.3066 20.8438C10.8958 20.7922 10.6049 20.4177 10.6562 20.0068C10.7077 19.5959 11.0822 19.3041 11.4932 19.3555C12.2635 19.4517 13.0324 19.5 13.75 19.5C14.1666 19.5 14.646 19.3124 15.8174 18.3916C16.9697 17.4858 18.5946 16.042 21.3164 13.7686C21.5856 13.4523 21.5416 13.0307 21.293 12.8027C21.285 12.7955 21.2771 12.7879 21.2695 12.7803C21.0979 12.6086 20.9511 12.5661 20.8193 12.5684C20.6654 12.5711 20.4378 12.6388 20.1436 12.8545C20.1251 12.868 20.1056 12.8808 20.0859 12.8926C20.007 12.9399 19.8441 13.0601 19.584 13.2617C19.3463 13.4459 19.0292 13.6965 18.707 13.9443C18.3788 14.1968 17.9078 14.1358 17.6553 13.8076C17.4027 13.4793 17.4647 13.0084 17.793 12.7559C18.1206 12.5038 18.4037 12.2794 18.666 12.0762C18.8911 11.9017 19.1143 11.732 19.2822 11.627C19.7317 11.3029 20.2449 11.078 20.793 11.0684ZM13.25 1.25C13.4558 1.25 13.6582 1.26529 13.833 1.27734C14.0153 1.28991 14.1788 1.29979 14.3496 1.2998C14.7071 1.2998 15.0158 1.55278 15.0859 1.90332L15.1855 2.40332C15.1882 2.41673 15.1904 2.4308 15.1924 2.44434C15.2095 2.5633 15.2647 2.63327 15.3145 2.66699L15.335 2.67969L15.377 2.70117C15.3903 2.70892 15.4032 2.71801 15.416 2.72656C15.4743 2.76528 15.5698 2.78595 15.7129 2.73828L16.1631 2.58887L16.2139 2.57324C16.4692 2.50779 16.7424 2.58128 16.9307 2.76953C17.5235 3.36237 17.937 4.0758 18.1709 4.89453C18.256 5.19324 18.1488 5.51375 17.9004 5.7002L17.5137 5.99023C17.4461 6.04651 17.4004 6.12875 17.4004 6.25C17.4004 6.37125 17.4461 6.45349 17.5137 6.50977L17.9004 6.7998C18.1489 6.98632 18.2562 7.30764 18.1709 7.60645C17.9369 8.42495 17.5233 9.13776 16.9307 9.73047C16.7299 9.93123 16.4325 10.0017 16.1631 9.91211L15.7129 9.76172C15.6498 9.74072 15.5244 9.7382 15.375 9.80273C15.2321 9.90681 15.2029 9.98313 15.1924 10.0566C15.1904 10.0702 15.1882 10.0842 15.1855 10.0977L15.0859 10.5977C15.0307 10.8728 14.8255 11.0938 14.5557 11.1709C14.1414 11.2892 13.7222 11.3506 13.2998 11.3506C12.8775 11.3506 12.4582 11.2892 12.0439 11.1709C11.7742 11.0938 11.5699 10.8727 11.5146 10.5977L11.415 10.0977C11.4124 10.0842 11.4092 10.0702 11.4072 10.0566C11.3878 9.92066 11.3188 9.84851 11.2646 9.82129C11.2369 9.80739 11.2094 9.79165 11.1836 9.77441C11.1253 9.7356 11.03 9.71396 10.8867 9.76172L10.4375 9.91211C10.1681 10.0019 9.87077 9.93116 9.66992 9.73047C9.07716 9.13771 8.66267 8.42504 8.42871 7.60645C8.34336 7.30756 8.45152 6.98631 8.7002 6.7998L9.08496 6.51074C9.15327 6.45445 9.2002 6.372 9.2002 6.25C9.2002 6.128 9.15327 6.04555 9.08496 5.98926L8.7002 5.7002C8.45165 5.51379 8.3436 5.19328 8.42871 4.89453C8.66265 4.07575 9.07706 3.36239 9.66992 2.76953L9.70801 2.7334C9.90714 2.56046 10.1848 2.50468 10.4375 2.58887L10.8867 2.73828C11.2797 2.86927 11.4923 3.29454 11.3613 3.6875C11.2326 4.07303 10.8212 4.28421 10.4346 4.16797C10.2788 4.37215 10.1482 4.59406 10.042 4.83398C10.4571 5.17752 10.7002 5.68499 10.7002 6.25C10.7002 6.81501 10.4571 7.32248 10.042 7.66602C10.1482 7.90588 10.2788 8.12789 10.4346 8.33203C10.8777 8.1898 11.4544 8.17132 11.9775 8.50098C12.4852 8.77259 12.7977 9.26921 12.8857 9.80273L12.8887 9.82129C13.0266 9.84063 13.1636 9.85058 13.2998 9.85059C13.4359 9.85059 13.5731 9.8406 13.7109 9.82129L13.7148 9.80273C13.8135 9.20568 14.1722 8.80099 14.584 8.52637L14.624 8.50098C14.6373 8.49329 14.6513 8.48636 14.665 8.47949C15.0922 8.26598 15.6403 8.16487 16.165 8.33203C16.321 8.12772 16.4523 7.90612 16.5586 7.66602C16.1435 7.32248 15.9004 6.81501 15.9004 6.25C15.9004 5.68493 16.1434 5.17752 16.5586 4.83398C16.4524 4.59399 16.3209 4.3722 16.165 4.16797C15.7217 4.31022 15.1445 4.3284 14.6211 3.99805C14.1385 3.73927 13.8327 3.2772 13.7285 2.77344C13.5416 2.76055 13.3938 2.75 13.25 2.75C12.9725 2.75001 12.6918 2.78952 12.4062 2.87109C12.0081 2.98485 11.5925 2.7545 11.4785 2.35645C11.3648 1.95819 11.5959 1.5425 11.9941 1.42871C12.4084 1.31039 12.8277 1.25001 13.25 1.25ZM13.25 4.84961C14.0232 4.84965 14.6504 5.47683 14.6504 6.25C14.6504 7.02317 14.0232 7.65035 13.25 7.65039C12.4768 7.65039 11.8496 7.0232 11.8496 6.25C11.8496 5.4768 12.4768 4.84961 13.25 4.84961Z"
      fill={path2Color}
    />
  </svg>
)

// SVG content
const PickupDeliveryIcon = ({
  width = "56",
  height = "56",
  color1 = "#586FCC", // For the first path
  color2 = "#617AD680", // For the second path
  color3 = "#1D2540",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.1174 28.8405C17.7942 29.1928 17.2447 29.1928 16.9216 28.8405C15.8879 27.7123 13.7307 25.2985 12.2024 23.1728C11.1524 21.7133 10.5481 20.4895 10.5037 18.8993C10.4092 15.5697 12.7461 12.527 16.0069 11.8457C20.5441 10.8983 24.5399 14.3353 24.5399 18.7068C24.5399 20.3927 23.9309 21.655 22.8389 23.174C21.3082 25.2985 19.1511 27.7123 18.1174 28.8405Z"
      fill={color1}
    />
    <path
      d="M48.3828 40.4792C48.0596 40.8315 47.5101 40.8315 47.187 40.4792C46.1533 39.351 43.9961 36.9372 42.4678 34.8115C41.4178 33.352 40.8135 32.1282 40.7691 30.538C40.6746 27.2083 43.0115 24.1657 46.2723 23.4843C50.8095 22.537 54.8053 25.974 54.8053 30.3455C54.8053 32.0313 54.1963 33.2937 53.1043 34.8127C51.5736 36.9372 49.4165 39.351 48.3828 40.4792Z"
      fill={color2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6667 5.83398C11.6667 4.86749 12.4502 4.08398 13.4167 4.08398C17.4405 4.08398 20.108 6.50803 21.3553 9.26996C21.9725 10.6365 22.2658 12.1231 22.2204 13.5198C22.1755 14.8997 21.7924 16.3219 20.9082 17.4272C19.037 19.7661 16.039 23.465 14.7749 25.0209C14.4438 25.4283 13.9474 25.6656 13.4224 25.6673C12.8975 25.669 12.3995 25.435 12.0658 25.0298C10.7059 23.3786 7.56065 19.5303 5.91029 17.4084C3.76708 14.6528 3.9674 11.1729 5.94726 8.79701C6.56599 8.05452 7.66948 7.95419 8.41197 8.57292C9.15446 9.19165 9.25479 10.2951 8.63606 11.0376C7.6993 12.1618 7.54957 13.8151 8.67303 15.2596C9.86987 16.7984 11.8889 19.2883 13.4094 21.1487C14.8602 19.3587 16.8176 16.9377 18.1751 15.2408C18.4576 14.8877 18.6942 14.2682 18.7223 13.406C18.7498 12.5605 18.5692 11.6044 18.1655 10.7105C17.3712 8.9516 15.8095 7.58398 13.4167 7.58398C12.4502 7.58398 11.6667 6.80048 11.6667 5.83398ZM15.7501 13.4173C15.7501 14.706 14.7054 15.7507 13.4167 15.7507C12.1281 15.7507 11.0834 14.706 11.0834 13.4173C11.0834 12.1287 12.1281 11.084 13.4167 11.084C14.7054 11.084 15.7501 12.1287 15.7501 13.4173ZM44.8979 25.1038C44.8979 26.3925 43.8533 27.4371 42.5646 27.4371C41.276 27.4371 40.2313 26.3925 40.2313 25.1038C40.2313 23.8152 41.276 22.7705 42.5646 22.7705C43.8533 22.7705 44.8979 23.8152 44.8979 25.1038ZM13.4167 32.6673C14.3832 32.6673 15.1667 31.8838 15.1667 30.9173C15.1667 29.9508 14.3832 29.1673 13.4167 29.1673C12.4503 29.1673 11.6667 29.9508 11.6667 30.9173C11.6667 31.8838 12.4503 32.6673 13.4167 32.6673ZM15.1667 36.7506C15.1667 37.7171 14.3832 38.5006 13.4167 38.5006C12.4503 38.5006 11.6667 37.7171 11.6667 36.7506C11.6667 35.7842 12.4503 35.0007 13.4167 35.0007C14.3832 35.0007 15.1667 35.7842 15.1667 36.7506ZM13.4167 44.334C14.3832 44.334 15.1667 43.5505 15.1667 42.584C15.1667 41.6175 14.3832 40.834 13.4167 40.834C12.4503 40.834 11.6667 41.6175 11.6667 42.584C11.6667 43.5505 12.4503 44.334 13.4167 44.334ZM15.1667 48.4173C15.1667 49.3838 14.3832 50.1673 13.4167 50.1673C12.4503 50.1673 11.6667 49.3838 11.6667 48.4173C11.6667 47.4508 12.4503 46.6673 13.4167 46.6673C14.3832 46.6673 15.1667 47.4508 15.1667 48.4173ZM19.2501 50.1673C20.2166 50.1673 21.0001 49.3838 21.0001 48.4173C21.0001 47.4508 20.2166 46.6673 19.2501 46.6673C18.2836 46.6673 17.5001 47.4508 17.5001 48.4173C17.5001 49.3838 18.2836 50.1673 19.2501 50.1673ZM26.8334 48.4173C26.8334 49.3838 26.0499 50.1673 25.0834 50.1673C24.1169 50.1673 23.3334 49.3838 23.3334 48.4173C23.3334 47.4508 24.1169 46.6673 25.0834 46.6673C26.0499 46.6673 26.8334 47.4508 26.8334 48.4173ZM30.9167 50.1673C31.8832 50.1673 32.6667 49.3838 32.6667 48.4173C32.6667 47.4508 31.8832 46.6673 30.9167 46.6673C29.9503 46.6673 29.1667 47.4508 29.1667 48.4173C29.1667 49.3838 29.9503 50.1673 30.9167 50.1673ZM38.5001 48.4173C38.5001 49.3838 37.7166 50.1673 36.7501 50.1673C35.7836 50.1673 35.0001 49.3838 35.0001 48.4173C35.0001 47.4508 35.7836 46.6673 36.7501 46.6673C37.7166 46.6673 38.5001 47.4508 38.5001 48.4173ZM42.5834 50.1673C43.5499 50.1673 44.3334 49.3838 44.3334 48.4173C44.3334 47.4508 43.5499 46.6673 42.5834 46.6673C41.6169 46.6673 40.8334 47.4508 40.8334 48.4173C40.8334 49.3838 41.6169 50.1673 42.5834 50.1673ZM44.3334 42.584C44.3334 43.5505 43.5499 44.334 42.5834 44.334C41.6169 44.334 40.8334 43.5505 40.8334 42.584C40.8334 41.6175 41.6169 40.834 42.5834 40.834C43.5499 40.834 44.3334 41.6175 44.3334 42.584ZM42.8687 16.334C41.9022 16.334 41.1187 17.1175 41.1187 18.084C41.1187 19.0505 41.9022 19.834 42.8687 19.834C45.2616 19.834 46.8232 21.2016 47.6176 22.9605C48.0213 23.8544 48.2018 24.8105 48.1743 25.656C48.1463 26.5182 47.9097 27.1377 47.6272 27.4908C46.2696 29.1877 44.3122 31.6087 42.8615 33.3988C41.341 31.5383 39.3219 29.0484 38.1251 27.5096C37.0016 26.0651 37.1514 24.4118 38.0881 23.2876C38.7069 22.5451 38.6065 21.4417 37.864 20.8229C37.1215 20.2042 36.0181 20.3045 35.3993 21.047C33.4195 23.4229 33.2191 26.9028 35.3624 29.6584C37.0127 31.7803 40.158 35.6286 41.5178 37.2798C41.8516 37.685 42.3496 37.919 42.8745 37.9173C43.3995 37.9156 43.8959 37.6783 44.2269 37.2709C45.4911 35.715 48.4891 32.0161 50.3602 29.6772C51.2444 28.572 51.6276 27.1497 51.6725 25.7698C51.7179 24.3731 51.4245 22.8865 50.8074 21.52C49.5601 18.758 46.8926 16.334 42.8687 16.334Z"
      fill={color3}
    />
  </svg>
);

const BeyondIcon = ({
  width = "56",
  height = "56",
  color = "#5B6EF5",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <rect width="56" height="56" rx="8" fill={color} />
    <text
      x="28"
      y="39"
      fill="white"
      fontSize="34"
      fontFamily="system-ui, -apple-system, sans-serif"
      fontWeight="bold"
      textAnchor="middle"
    >
      B
    </text>
  </svg>
);

const ExclusiveIcon = ({
  width = "56",
  height = "56",
  color = "#F59E0B",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <rect width="56" height="56" rx="8" fill={color} />
    <text
      x="28"
      y="39"
      fill="white"
      fontSize="34"
      fontFamily="system-ui, -apple-system, sans-serif"
      fontWeight="bold"
      textAnchor="middle"
    >
      E
    </text>
  </svg>
);

const HotshotIcon = ({
  width = "56",
  height = "56",
  color = "#EF4444",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <rect width="56" height="56" rx="8" fill={color} />
    <text
      x="28"
      y="39"
      fill="white"
      fontSize="34"
      fontFamily="system-ui, -apple-system, sans-serif"
      fontWeight="bold"
      textAnchor="middle"
    >
      H
    </text>
  </svg>
);

const MoveOrderIcon = ({
  width = "56",
  height = "56",
  color1 = "#FF2D78",
  color2 = "#15C989",
  color3 = "#1D2540",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.1174 28.8405C17.7942 29.1928 17.2447 29.1928 16.9216 28.8405C15.8879 27.7123 13.7307 25.2985 12.2024 23.1728C11.1524 21.7133 10.5481 20.4895 10.5037 18.8993C10.4092 15.5697 12.7461 12.527 16.0069 11.8457C20.5441 10.8983 24.5399 14.3353 24.5399 18.7068C24.5399 20.3927 23.9309 21.655 22.8389 23.174C21.3082 25.2985 19.1511 27.7123 18.1174 28.8405Z"
      fill={color1}
    />
    <path
      d="M48.3828 52.1452C48.0596 52.4975 47.5101 52.4975 47.187 52.1452C46.1533 51.017 43.9961 48.6032 42.4678 46.4775C41.4178 45.018 40.8135 43.7942 40.7691 42.204C40.6746 38.8744 43.0115 35.8317 46.2723 35.1504C50.8095 34.203 54.8053 37.64 54.8053 42.0115C54.8053 43.6974 54.1963 44.9597 53.1043 46.4787C51.5736 48.6032 49.4165 51.017 48.3828 52.1452Z"
      fill={color2}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.4167 4.08203C12.4502 4.08203 11.6667 4.86553 11.6667 5.83203C11.6667 6.79853 12.4502 7.58203 13.4167 7.58203C15.8095 7.58203 17.3712 8.94965 18.1655 10.7086C18.5692 11.6024 18.7498 12.5585 18.7223 13.4041C18.6942 14.2663 18.4576 14.8857 18.1751 15.2388C16.8176 16.9358 14.8602 19.3567 13.4094 21.1468C11.8889 19.2864 9.86987 16.7964 8.67303 15.2576C7.54957 13.8132 7.6993 12.1598 8.63606 11.0357C9.25479 10.2932 9.15446 9.1897 8.41197 8.57097C7.66948 7.95224 6.56599 8.05256 5.94726 8.79505C3.9674 11.1709 3.76708 14.6509 5.91029 17.4064C7.56065 19.5283 10.7059 23.3766 12.0658 25.0279C12.3995 25.4331 12.8975 25.6671 13.4224 25.6654C13.9474 25.6636 14.4438 25.4263 14.7749 25.0189C16.039 23.463 19.037 19.7642 20.9082 17.4252C21.7924 16.32 22.1755 14.8978 22.2204 13.5178C22.2658 12.1212 21.9725 10.6346 21.3553 9.268C20.108 6.50608 17.4405 4.08203 13.4167 4.08203ZM13.4167 15.7487C14.7054 15.7487 15.7501 14.704 15.7501 13.4154C15.7501 12.1267 14.7054 11.082 13.4167 11.082C12.1281 11.082 11.0834 12.1267 11.0834 13.4154C11.0834 14.704 12.1281 15.7487 13.4167 15.7487ZM42.5646 39.1018C43.8533 39.1018 44.8979 38.0572 44.8979 36.7685C44.8979 35.4798 43.8533 34.4352 42.5646 34.4352C41.276 34.4352 40.2313 35.4798 40.2313 36.7685C40.2313 38.0572 41.276 39.1018 42.5646 39.1018ZM41.1187 29.7487C41.1187 28.7822 41.9022 27.9987 42.8687 27.9987C46.8926 27.9987 49.5601 30.4227 50.8074 33.1847C51.4245 34.5512 51.7179 36.0378 51.6725 37.4345C51.6276 38.8144 51.2444 40.2367 50.3602 41.3419C48.4891 43.6808 45.4911 47.3797 44.2269 48.9356C43.8959 49.343 43.3995 49.5803 42.8745 49.582C42.3496 49.5838 41.8516 49.3497 41.5178 48.9445C40.158 47.2933 37.0127 43.445 35.3624 41.3231C33.2191 38.5675 33.4195 35.0876 35.3993 32.7117C36.0181 31.9692 37.1215 31.8689 37.864 32.4876C38.6065 33.1064 38.7069 34.2099 38.0881 34.9523C37.1514 36.0765 37.0016 37.7299 38.1251 39.1743C39.3219 40.7131 41.341 43.203 42.8615 45.0635C44.3122 43.2734 46.2696 40.8524 47.6272 39.1555C47.9097 38.8024 48.1463 38.183 48.1743 37.3207C48.2018 36.4752 48.0213 35.5191 47.6176 34.6252C46.8232 32.8663 45.2616 31.4987 42.8687 31.4987C41.9022 31.4987 41.1187 30.7152 41.1187 29.7487ZM39.0208 20.0433C39.7036 19.3593 39.7027 18.2513 39.0187 17.5684C38.3347 16.8856 37.2267 16.8865 36.5438 17.5705L17.5855 36.5602C16.9026 37.2442 16.9036 38.3522 17.5875 39.0351C18.2715 39.7179 19.3796 39.717 20.0624 39.033L39.0208 20.0433Z"
      fill={color3}
    />
  </svg>
);
const PickupLinehaulIcon = ({
  width = "56",
  height = "56",
}) => (
<svg width={width} height={height} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M55.4167 35.1399V40.6933C55.4167 43.3533 53.2583 45.4999 50.61 45.4999H41.5567C38.9083 45.4999 36.75 43.3416 36.75 40.6933V31.6399C36.75 28.9799 38.9083 26.8333 41.5567 26.8333H50.61C53.27 26.8333 55.4167 28.9916 55.4167 31.6399V37.1933V35.1399Z" fill="#FFBA07"/>
<path d="M18.1164 28.8412C17.7933 29.1936 17.2438 29.1936 16.9206 28.8412C15.8869 27.7131 13.7298 25.2992 12.2014 23.1736C11.1514 21.7141 10.5471 20.4902 10.5028 18.9001C10.4083 15.5704 12.7451 12.5277 16.0059 11.8464C20.5431 10.8991 24.5389 14.3361 24.5389 18.7076C24.5389 20.3934 23.9299 21.6557 22.8379 23.1747C21.3073 25.2992 19.1501 27.7131 18.1164 28.8412Z" fill="#FF2D78"/>
<path d="M13.417 46.667C14.3832 46.6673 15.167 47.4507 15.167 48.417C15.1668 49.3831 14.3831 50.1666 13.417 50.167C12.4506 50.167 11.6672 49.3833 11.667 48.417C11.667 47.4505 12.4505 46.667 13.417 46.667ZM19.25 46.667C20.2163 46.6672 21 47.4506 21 48.417C20.9998 49.3832 20.2162 50.1668 19.25 50.167C18.2836 50.167 17.5002 49.3833 17.5 48.417C17.5 47.4505 18.2835 46.667 19.25 46.667ZM25.083 46.667C26.0494 46.6671 26.833 47.4506 26.833 48.417C26.8328 49.3833 26.0493 50.1669 25.083 50.167C24.1167 50.1669 23.3332 49.3833 23.333 48.417C23.333 47.4506 24.1166 46.6671 25.083 46.667ZM30.917 46.667C31.8832 46.6673 32.667 47.4507 32.667 48.417C32.6668 49.3831 31.8831 50.1666 30.917 50.167C29.9506 50.167 29.1672 49.3833 29.167 48.417C29.167 47.4505 29.9505 46.667 30.917 46.667ZM36.75 46.667C37.7163 46.6672 38.5 47.4506 38.5 48.417C38.4998 49.3832 37.7162 50.1668 36.75 50.167C35.7836 50.167 35.0002 49.3833 35 48.417C35 47.4505 35.7835 46.667 36.75 46.667ZM42.583 46.667C43.5494 46.6671 44.333 47.4506 44.333 48.417C44.3328 49.3833 43.5493 50.1669 42.583 50.167C41.6167 50.1669 40.8332 49.3833 40.833 48.417C40.833 47.4506 41.6166 46.6671 42.583 46.667ZM13.417 40.834C14.3832 40.8343 15.167 41.6177 15.167 42.584C15.1666 43.55 14.383 44.3336 13.417 44.334C12.4507 44.334 11.6673 43.5502 11.667 42.584C11.667 41.6175 12.4505 40.834 13.417 40.834ZM46.666 21.583C50.2108 21.583 53.083 24.4552 53.083 28V37.333C53.083 40.8778 50.2108 43.75 46.666 43.75H46.083C45.1165 43.75 44.333 42.9665 44.333 42C44.333 41.0335 45.1165 40.25 46.083 40.25H46.666C48.2779 40.25 49.583 38.9448 49.583 37.333V28C49.583 26.3882 48.2779 25.083 46.666 25.083H36.166C34.5543 25.0832 33.25 26.3883 33.25 28V37.333C33.25 38.9447 34.5543 40.2498 36.166 40.25H38.9316C39.898 40.2502 40.6816 41.0336 40.6816 42C40.6816 42.9664 39.898 43.7498 38.9316 43.75H36.166C32.6213 43.7498 29.75 40.8777 29.75 37.333V28C29.75 24.4553 32.6213 21.5832 36.166 21.583H46.666ZM13.417 35C14.3831 35.0004 15.1668 35.7839 15.167 36.75C15.1668 37.7161 14.3831 38.4996 13.417 38.5C12.4506 38.5 11.6672 37.7163 11.667 36.75C11.6672 35.7837 12.4506 35 13.417 35ZM13.417 29.167C14.3832 29.1673 15.167 29.9507 15.167 30.917C15.1668 31.8831 14.3831 32.6666 13.417 32.667C12.4506 32.667 11.6672 31.8833 11.667 30.917C11.667 29.9505 12.4505 29.167 13.417 29.167ZM13.416 4.08301C17.4398 4.08301 20.1072 6.50761 21.3545 9.26953C21.9716 10.6361 22.2651 12.1229 22.2197 13.5195C22.1748 14.8993 21.7923 16.3216 20.9082 17.4268C19.0371 19.7657 16.0386 23.4646 14.7744 25.0205C14.4434 25.4278 13.9467 25.6653 13.4219 25.667C12.897 25.6687 12.3991 25.4344 12.0654 25.0293C10.7057 23.3782 7.56061 19.5302 5.91016 17.4082C3.76694 14.6526 3.96741 11.1718 5.94727 8.7959C6.566 8.05392 7.6688 7.9539 8.41113 8.57227C9.15362 9.191 9.25447 10.2946 8.63574 11.0371C7.69901 12.1612 7.54941 13.8144 8.67285 15.2588C9.86969 16.7976 11.8887 19.288 13.4092 21.1484C14.8599 19.3584 16.8172 16.9372 18.1748 15.2402C18.4573 14.8872 18.6936 14.2675 18.7217 13.4053C18.7492 12.5598 18.5687 11.6038 18.165 10.71C17.3707 8.95105 15.8089 7.58301 13.416 7.58301C12.4496 7.58288 11.666 6.79943 11.666 5.83301C11.6662 4.86674 12.4497 4.08314 13.416 4.08301ZM13.416 11.083C14.7047 11.083 15.75 12.1283 15.75 13.417C15.7498 14.7055 14.7046 15.75 13.416 15.75C12.1276 15.7498 11.0832 14.7054 11.083 13.417C11.083 12.1284 12.1275 11.0832 13.416 11.083Z" fill="#1D2540"/>
</svg>
);

const LinehaulDeliveryIcon = ({
  width = "56",
  height = "56",
}) => (
<svg width={width} height={height} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M48.3821 45.1452C48.0589 45.4975 47.5094 45.4975 47.1862 45.1452C46.1526 44.017 43.9954 41.6032 42.4671 39.4775C41.4171 38.018 40.8127 36.7942 40.7684 35.204C40.6739 31.8744 43.0107 28.8317 46.2716 28.1504C50.8087 27.203 54.8046 30.64 54.8046 35.0115C54.8046 36.6974 54.1956 37.9597 53.1036 39.4787C51.5729 41.6032 49.4157 44.017 48.3821 45.1452Z" fill="#15C989"/>
<path d="M28.9616 18.8067V24.36C28.9616 27.02 26.8033 29.1667 24.1549 29.1667H15.1016C12.4533 29.1667 10.2949 27.0083 10.2949 24.36V15.3067C10.2949 12.6467 12.4533 10.5 15.1016 10.5H24.1549C26.8149 10.5 28.9616 12.6583 28.9616 15.3067V20.86V18.8067Z" fill="#FFBA07"/>
<path d="M13.417 46.667C14.3833 46.6672 15.167 47.4506 15.167 48.417C15.1668 49.3832 14.3832 50.1668 13.417 50.167C12.4506 50.1669 11.6672 49.3833 11.667 48.417C11.667 47.4505 12.4505 46.667 13.417 46.667ZM19.25 46.667C20.2165 46.667 21 47.4505 21 48.417C20.9998 49.3833 20.2164 50.1669 19.25 50.167C18.2836 50.1669 17.5002 49.3833 17.5 48.417C17.5 47.4505 18.2835 46.667 19.25 46.667ZM25.083 46.667C26.0495 46.667 26.833 47.4505 26.833 48.417C26.8328 49.3833 26.0494 50.167 25.083 50.167C24.1168 50.1668 23.3332 49.3832 23.333 48.417C23.333 47.4506 24.1167 46.6672 25.083 46.667ZM30.917 46.667C31.8833 46.6672 32.667 47.4506 32.667 48.417C32.6668 49.3832 31.8832 50.1668 30.917 50.167C29.9506 50.1669 29.1672 49.3833 29.167 48.417C29.167 47.4505 29.9505 46.667 30.917 46.667ZM36.75 46.667C37.7165 46.667 38.5 47.4505 38.5 48.417C38.4998 49.3833 37.7164 50.1669 36.75 50.167C35.7836 50.1669 35.0002 49.3833 35 48.417C35 47.4505 35.7835 46.667 36.75 46.667ZM42.583 46.667C43.5495 46.667 44.333 47.4505 44.333 48.417C44.3328 49.3833 43.5494 50.167 42.583 50.167C41.6168 50.1668 40.8332 49.3832 40.833 48.417C40.833 47.4506 41.6167 46.6672 42.583 46.667ZM13.417 40.834C14.3833 40.8342 15.167 41.6176 15.167 42.584C15.1666 43.55 14.3831 44.3338 13.417 44.334C12.4507 44.3339 11.6673 43.5502 11.667 42.584C11.667 41.6175 12.4505 40.834 13.417 40.834ZM42.8682 21C46.8919 21 49.5603 23.4237 50.8076 26.1855C51.4247 27.552 51.7182 29.039 51.6729 30.4355C51.628 31.8154 51.2443 33.2376 50.3604 34.3428C48.4892 36.6817 45.4907 40.3806 44.2266 41.9365C43.8955 42.3439 43.399 42.5813 42.874 42.583C42.3493 42.5846 41.8512 42.3513 41.5176 41.9463C40.1577 40.2951 37.0127 36.4461 35.3623 34.3242C33.2192 31.5687 33.4196 28.0887 35.3994 25.7129C36.0182 24.9705 37.1218 24.8706 37.8643 25.4893C38.6064 26.108 38.7065 27.2117 38.0879 27.9541C37.1514 29.0782 37.0017 30.7315 38.125 32.1758C39.3218 33.7145 41.3409 36.2041 42.8613 38.0645C44.312 36.2745 46.2694 33.8541 47.627 32.1572C47.9094 31.8042 48.1457 31.1844 48.1738 30.3223C48.2013 29.4768 48.0208 28.5208 47.6172 27.627C46.8228 25.868 45.261 24.5 42.8682 24.5C41.9019 24.4997 41.1182 23.7163 41.1182 22.75C41.1182 21.7837 41.9019 21.0003 42.8682 21ZM13.417 35C14.3832 35.0002 15.1668 35.7838 15.167 36.75C15.1668 37.7162 14.3832 38.4998 13.417 38.5C12.4506 38.5 11.6672 37.7163 11.667 36.75C11.6672 35.7837 12.4506 35 13.417 35ZM13.417 29.167C14.3833 29.1672 15.167 29.9506 15.167 30.917C15.1668 31.8832 14.3832 32.6668 13.417 32.667C12.4506 32.6669 11.6672 31.8833 11.667 30.917C11.667 29.9505 12.4505 29.167 13.417 29.167ZM42.5645 27.4365C43.853 27.4365 44.8973 28.481 44.8975 29.7695C44.8975 31.0582 43.8531 32.1035 42.5645 32.1035C41.2758 32.1035 40.2314 31.0582 40.2314 29.7695C40.2316 28.481 41.2759 27.4366 42.5645 27.4365ZM20.2119 5.25C23.7566 5.25018 26.6279 8.12227 26.6279 11.667V21C26.6278 24.5446 23.7565 27.4168 20.2119 27.417H17.4463C16.48 27.4168 15.6965 26.6332 15.6963 25.667C15.6963 24.7006 16.4799 23.9172 17.4463 23.917H20.2119C21.8235 23.9168 23.1278 22.6116 23.1279 21V11.667C23.1279 10.0553 21.8236 8.75018 20.2119 8.75H9.71191C8.10008 8.75 6.79492 10.0552 6.79492 11.667V21C6.7951 22.6117 8.10019 23.917 9.71191 23.917H10.2949C11.2614 23.917 12.0449 24.7005 12.0449 25.667C12.0447 26.6333 11.2613 27.417 10.2949 27.417H9.71191C6.16719 27.417 3.2951 24.5447 3.29492 21V11.667C3.29492 8.12216 6.16708 5.25 9.71191 5.25H20.2119Z" fill="#1D2540"/>
</svg>
);

const TransferLinehaulIcon = ({
  width = "56",
  height = "56",
}) => (
<svg width={width} height={height} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M55.4167 35.1399V40.6933C55.4167 43.3533 53.2583 45.4999 50.61 45.4999H41.5567C38.9083 45.4999 36.75 43.3416 36.75 40.6933V31.6399C36.75 28.9799 38.9083 26.8333 41.5567 26.8333H50.61C53.27 26.8333 55.4167 28.9916 55.4167 31.6399V37.1933V35.1399Z" fill="#617AD6" fill-opacity="0.5"/>
<path d="M28.9616 18.8067V24.36C28.9616 27.02 26.8033 29.1667 24.1549 29.1667H15.1016C12.4533 29.1667 10.2949 27.0083 10.2949 24.36V15.3067C10.2949 12.6467 12.4533 10.5 15.1016 10.5H24.1549C26.8149 10.5 28.9616 12.6583 28.9616 15.3067V20.86V18.8067Z" fill="#FFBA07"/>
<path d="M13.418 46.667C14.3843 46.6672 15.168 47.4506 15.168 48.417C15.1678 49.3832 14.3842 50.1668 13.418 50.167C12.4516 50.1669 11.6681 49.3833 11.668 48.417C11.668 47.4505 12.4515 46.667 13.418 46.667ZM19.251 46.667C20.2174 46.667 21.001 47.4505 21.001 48.417C21.0008 49.3833 20.2173 50.1669 19.251 50.167C18.2846 50.1669 17.5012 49.3833 17.501 48.417C17.501 47.4505 18.2845 46.667 19.251 46.667ZM25.084 46.667C26.0505 46.667 26.834 47.4505 26.834 48.417C26.8338 49.3833 26.0504 50.167 25.084 50.167C24.1177 50.1668 23.3342 49.3832 23.334 48.417C23.334 47.4506 24.1176 46.6672 25.084 46.667ZM30.918 46.667C31.8843 46.6672 32.668 47.4506 32.668 48.417C32.6678 49.3832 31.8842 50.1668 30.918 50.167C29.9516 50.1669 29.1681 49.3833 29.168 48.417C29.168 47.4505 29.9515 46.667 30.918 46.667ZM36.751 46.667C37.7174 46.667 38.501 47.4505 38.501 48.417C38.5008 49.3833 37.7173 50.1669 36.751 50.167C35.7846 50.1669 35.0012 49.3833 35.001 48.417C35.001 47.4505 35.7845 46.667 36.751 46.667ZM42.584 46.667C43.5505 46.667 44.334 47.4505 44.334 48.417C44.3338 49.3833 43.5504 50.167 42.584 50.167C41.6177 50.1668 40.8342 49.3832 40.834 48.417C40.834 47.4506 41.6176 46.6672 42.584 46.667ZM13.418 40.834C14.3843 40.8342 15.168 41.6176 15.168 42.584C15.1676 43.55 14.3841 44.3338 13.418 44.334C12.4517 44.3339 11.6683 43.5502 11.668 42.584C11.668 41.6175 12.4515 40.834 13.418 40.834ZM31.5127 31.8926C32.4792 31.8926 33.2627 32.6761 33.2627 33.6426V37.3613C33.2629 38.972 34.569 40.2773 36.1797 40.2773H38.7979C39.7639 40.2775 40.5475 41.0613 40.5479 42.0273C40.5479 42.9937 39.7642 43.7771 38.7979 43.7773H36.1797C32.636 43.7773 29.7629 40.905 29.7627 37.3613V33.6426C29.7627 32.6761 30.5462 31.8926 31.5127 31.8926ZM51.3213 31.8926C52.2876 31.8928 53.0713 32.6762 53.0713 33.6426V37.3613C53.0711 40.905 50.198 43.7773 46.6543 43.7773H46.3945C45.4283 43.777 44.6445 42.9936 44.6445 42.0273C44.6449 41.0614 45.4286 40.2777 46.3945 40.2773H46.6543C48.265 40.2773 49.5711 38.972 49.5713 37.3613V33.6426C49.5713 32.6763 50.3551 31.8929 51.3213 31.8926ZM13.418 35C14.3842 35.0002 15.1678 35.7838 15.168 36.75C15.1678 37.7162 14.3842 38.4998 13.418 38.5C12.4516 38.5 11.6681 37.7163 11.668 36.75C11.6681 35.7837 12.4516 35 13.418 35ZM41.5312 16.3203C45.5549 16.3203 48.2223 18.7441 49.4697 21.5059C50.0868 22.8723 50.3803 24.3593 50.335 25.7559C50.2901 27.1358 49.9066 28.5579 49.0225 29.6631C47.1515 32.0018 44.1539 35.7008 42.8896 37.2568C42.5586 37.6642 42.062 37.9015 41.5371 37.9033C41.0124 37.9051 40.5144 37.6715 40.1807 37.2666C38.8208 35.6154 35.6748 31.7664 34.0244 29.6445C31.8815 26.889 32.0818 23.409 34.0615 21.0332C34.6803 20.2907 35.7839 20.1908 36.5264 20.8096C37.2688 21.4283 37.3697 22.5319 36.751 23.2744C35.8143 24.3985 35.6638 26.0517 36.7871 27.4961C37.9839 29.0349 40.0039 31.5243 41.5244 33.3848C42.9751 31.5948 44.9326 29.1744 46.29 27.4775C46.5725 27.1245 46.8088 26.5047 46.8369 25.6426C46.8644 24.7972 46.6838 23.841 46.2803 22.9473C45.4859 21.1884 43.9241 19.8203 41.5312 19.8203C40.5648 19.8203 39.7813 19.0368 39.7812 18.0703C39.7812 17.1038 40.5648 16.3203 41.5312 16.3203ZM13.418 29.167C14.3843 29.1672 15.168 29.9506 15.168 30.917C15.1678 31.8832 14.3842 32.6668 13.418 32.667C12.4516 32.6669 11.6681 31.8833 11.668 30.917C11.668 29.9505 12.4515 29.167 13.418 29.167ZM41.5312 23.3203C42.8198 23.3203 43.8641 24.3648 43.8643 25.6533C43.8643 26.942 42.8199 27.9873 41.5312 27.9873C40.2426 27.9873 39.1982 26.942 39.1982 25.6533C39.1984 24.3648 40.2427 23.3203 41.5312 23.3203ZM5.05859 15.5176C6.02482 15.5178 6.80848 16.3013 6.80859 17.2676V20.9863C6.80859 22.5971 8.11387 23.9032 9.72461 23.9033H9.98438C10.9507 23.9034 11.7341 24.687 11.7344 25.6533C11.7343 26.6197 10.9508 27.4033 9.98438 27.4033H9.72461C6.18088 27.4032 3.30859 24.5301 3.30859 20.9863V17.2676C3.30871 16.3012 4.09217 15.5176 5.05859 15.5176ZM24.8662 15.5176C25.8326 15.5176 26.6161 16.3012 26.6162 17.2676V20.9863C26.6162 24.53 23.7438 27.4031 20.2002 27.4033H17.582C16.6156 27.4033 15.8321 26.6198 15.832 25.6533C15.8323 24.687 16.6157 23.9033 17.582 23.9033H20.2002C21.8108 23.9031 23.1162 22.597 23.1162 20.9863V17.2676C23.1163 16.3014 23.9001 15.518 24.8662 15.5176ZM15.0771 -0.0537109C19.1007 -0.0535277 21.7684 2.37002 23.0156 5.13184C23.6327 6.49836 23.9263 7.98521 23.8809 9.38184C23.836 10.7617 23.4525 12.1839 22.5684 13.2891C20.6972 15.628 17.6987 19.3269 16.4346 20.8828C16.1035 21.2901 15.6069 21.5276 15.082 21.5293C14.5572 21.5309 14.0592 21.2967 13.7256 20.8916C12.3657 19.2403 9.22064 15.3924 7.57031 13.2705C5.42713 10.515 5.62764 7.03505 7.60742 4.65918C8.22615 3.91669 9.32978 3.81584 10.0723 4.43457C10.8147 5.05331 10.9146 6.15693 10.2959 6.89941C9.35922 8.02347 9.20979 9.67673 10.333 11.1211C11.5298 12.6599 13.5488 15.1503 15.0693 17.0107C16.5201 15.2207 18.4774 12.7995 19.835 11.1025C20.1174 10.7495 20.3538 10.1298 20.3818 9.26758C20.4093 8.42212 20.2288 7.46602 19.8252 6.57227C19.0309 4.81359 17.4696 3.44646 15.0771 3.44629C14.1108 3.44629 13.3274 2.6626 13.3271 1.69629C13.3271 0.729791 14.1106 -0.0537109 15.0771 -0.0537109ZM15.0771 6.94629C16.3656 6.94649 17.4102 7.99075 17.4102 9.2793C17.4101 10.5678 16.3656 11.6121 15.0771 11.6123C13.7885 11.6123 12.7432 10.5679 12.7432 9.2793C12.7432 7.99063 13.7885 6.94629 15.0771 6.94629Z" fill="#1D2540"/>
</svg>
);

const NewLinehaulIcon = ({
  width = "56",
  height = "56",
}) => (
<svg width={width} height={height} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M55.4167 35.1399V40.6933C55.4167 43.3533 53.2583 45.4999 50.61 45.4999H41.5567C38.9083 45.4999 36.75 43.3416 36.75 40.6933V31.6399C36.75 28.9799 38.9083 26.8333 41.5567 26.8333H50.61C53.27 26.8333 55.4167 28.9916 55.4167 31.6399V37.1933V35.1399Z" fill="#FFBA07"/>
<path d="M28.9616 18.8067V24.36C28.9616 27.02 26.8033 29.1667 24.1549 29.1667H15.1016C12.4533 29.1667 10.2949 27.0083 10.2949 24.36V15.3067C10.2949 12.6467 12.4533 10.5 15.1016 10.5H24.1549C26.8149 10.5 28.9616 12.6583 28.9616 15.3067V20.86V18.8067Z" fill="#FFBA07"/>
<path d="M13.417 46.667C14.3833 46.6672 15.167 47.4506 15.167 48.417C15.1668 49.3832 14.3832 50.1668 13.417 50.167C12.4506 50.1669 11.6672 49.3833 11.667 48.417C11.667 47.4505 12.4505 46.667 13.417 46.667ZM19.25 46.667C20.2165 46.667 21 47.4505 21 48.417C20.9998 49.3833 20.2164 50.1669 19.25 50.167C18.2836 50.1669 17.5002 49.3833 17.5 48.417C17.5 47.4505 18.2835 46.667 19.25 46.667ZM25.083 46.667C26.0495 46.667 26.833 47.4505 26.833 48.417C26.8328 49.3833 26.0494 50.167 25.083 50.167C24.1168 50.1668 23.3332 49.3832 23.333 48.417C23.333 47.4506 24.1167 46.6672 25.083 46.667ZM30.917 46.667C31.8833 46.6672 32.667 47.4506 32.667 48.417C32.6668 49.3832 31.8832 50.1668 30.917 50.167C29.9506 50.1669 29.1672 49.3833 29.167 48.417C29.167 47.4505 29.9505 46.667 30.917 46.667ZM36.75 46.667C37.7165 46.667 38.5 47.4505 38.5 48.417C38.4998 49.3833 37.7164 50.1669 36.75 50.167C35.7836 50.1669 35.0002 49.3833 35 48.417C35 47.4505 35.7835 46.667 36.75 46.667ZM42.583 46.667C43.5495 46.667 44.333 47.4505 44.333 48.417C44.3328 49.3833 43.5494 50.167 42.583 50.167C41.6168 50.1668 40.8332 49.3832 40.833 48.417C40.833 47.4506 41.6167 46.6672 42.583 46.667ZM13.417 40.834C14.3833 40.8342 15.167 41.6176 15.167 42.584C15.1666 43.55 14.3831 44.3338 13.417 44.334C12.4507 44.3339 11.6673 43.5502 11.667 42.584C11.667 41.6175 12.4505 40.834 13.417 40.834ZM46.666 21.583C50.2108 21.583 53.083 24.4552 53.083 28V37.333C53.083 40.8778 50.2108 43.75 46.666 43.75H46.083C45.1167 43.7498 44.333 42.9664 44.333 42C44.333 41.0336 45.1167 40.2502 46.083 40.25H46.666C48.2779 40.25 49.583 38.9448 49.583 37.333V28C49.583 26.3882 48.2779 25.083 46.666 25.083H36.166C34.5545 25.0834 33.25 26.3884 33.25 28V37.333C33.25 38.9446 34.5545 40.2496 36.166 40.25H38.9316C39.898 40.2502 40.6816 41.0336 40.6816 42C40.6816 42.9664 39.898 43.7498 38.9316 43.75H36.166C32.6215 43.7496 29.75 40.8776 29.75 37.333V28C29.75 24.4554 32.6215 21.5834 36.166 21.583H46.666ZM13.417 35C14.3832 35.0002 15.1668 35.7838 15.167 36.75C15.1668 37.7162 14.3832 38.4998 13.417 38.5C12.4506 38.5 11.6672 37.7163 11.667 36.75C11.6672 35.7837 12.4506 35 13.417 35ZM13.417 29.167C14.3833 29.1672 15.167 29.9506 15.167 30.917C15.1668 31.8832 14.3832 32.6668 13.417 32.667C12.4506 32.6669 11.6672 31.8833 11.667 30.917C11.667 29.9505 12.4505 29.167 13.417 29.167ZM20.2119 5.25C23.7566 5.25018 26.6279 8.12227 26.6279 11.667V21C26.6278 24.5446 23.7565 27.4168 20.2119 27.417H17.4463C16.48 27.4168 15.6965 26.6332 15.6963 25.667C15.6963 24.7006 16.4799 23.9172 17.4463 23.917H20.2119C21.8235 23.9168 23.1278 22.6116 23.1279 21V11.667C23.1279 10.0553 21.8236 8.75018 20.2119 8.75H9.71191C8.10008 8.75 6.79492 10.0552 6.79492 11.667V21C6.7951 22.6117 8.10019 23.917 9.71191 23.917H10.2949C11.2614 23.917 12.0449 24.7005 12.0449 25.667C12.0447 26.6333 11.2613 27.417 10.2949 27.417H9.71191C6.16719 27.417 3.2951 24.5447 3.29492 21V11.667C3.29492 8.12216 6.16708 5.25 9.71191 5.25H20.2119Z" fill="#1D2540"/>
</svg>
);


const PickupMultiIcon = ({
  width = "24",
  height = "24",
  color1 = "#FF2D78",
  color2 = "#1D2540",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5058 14.935L15.3853 17.16C14.9083 17.3675 14.3543 17.1485 14.1473 16.672L11.8318 11.084C11.6243 10.607 11.8433 10.053 12.3198 9.84601L17.4403 7.62101C17.9173 7.41351 18.4713 7.63251 18.6783 8.10901L20.9938 13.697C21.2008 14.173 20.9818 14.7275 20.5058 14.935Z"
      fill={color1}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 4C16 1.792 17.792 0 20 0C22.208 0 24 1.792 24 4C24 6.208 22.208 8 20 8C19.2993 8 18.6404 7.81951 18.0675 7.50252L19.6844 11.4047C20.052 12.26 19.6574 13.2511 18.8054 13.6225L16.43 14.6544C16.0501 14.8195 15.6084 14.6453 15.4433 14.2653C15.2783 13.8854 15.4525 13.4437 15.8324 13.2786L18.206 12.2475C18.3036 12.2048 18.3473 12.0912 18.3059 11.9961L18.3008 11.9841L15.9887 6.40421C15.9454 6.30976 15.8346 6.26743 15.7394 6.30876L15.6113 6.36456C15.2316 6.53005 14.7896 6.35637 14.6242 5.97665C14.4587 5.59693 14.6324 5.15495 15.0121 4.98947L15.141 4.93327C15.449 4.79931 15.7747 4.76427 16.083 4.814C16.0286 4.55115 16 4.27889 16 4ZM20.3953 2.20313C20.3953 1.87193 20.1265 1.60313 19.7953 1.60313C19.4641 1.60313 19.1953 1.87193 19.1953 2.20313V4.20312C19.1953 4.36232 19.2591 4.51376 19.3719 4.62656L20.1719 5.42656C20.2887 5.54416 20.4417 5.60312 20.5953 5.60312C20.7489 5.60312 20.9019 5.54336 21.0187 5.42656C21.2531 5.19216 21.2531 4.81332 21.0187 4.57812L20.3953 3.95313V2.20313ZM10.1993 5.88433C9.81615 5.72698 9.63309 5.28881 9.79045 4.90564L10.4913 3.1991C10.5668 3.0151 10.7124 2.86865 10.8959 2.79197C11.0795 2.7153 11.2859 2.71467 11.47 2.79023L13.1765 3.49105C13.5597 3.6484 13.7427 4.08658 13.5854 4.46974C13.428 4.8529 12.9898 5.03596 12.6067 4.8786L12.5752 4.86568L14.5754 9.65352C14.7351 10.0357 14.5547 10.475 14.1725 10.6347C13.7903 10.7943 13.351 10.6139 13.1914 10.2317L12.1957 7.84838L10.6187 8.53383C10.5217 8.57599 10.4775 8.68838 10.5195 8.78482L10.5246 8.79689L12.8367 14.3768C12.8801 14.4713 12.9908 14.5137 13.0861 14.4723L13.5779 14.2586C13.9578 14.0936 14.3996 14.2678 14.5646 14.6477C14.7297 15.0276 14.5555 15.4694 14.1755 15.6344L13.6844 15.8477L13.6841 15.8479C12.8267 16.2206 11.8311 15.8267 11.4593 14.9708L11.4544 14.9591L9.14102 9.37631C8.77306 8.52036 9.16718 7.52907 10.0208 7.15817L11.6174 6.46417L11.191 5.44369L11.178 5.47546C11.0206 5.85863 10.5825 6.04168 10.1993 5.88433ZM2.78407 5.59976L1.07662 6.42524C0.703696 6.60553 0.255232 6.44937 0.0749423 6.07645C-0.105347 5.70353 0.0508096 5.25507 0.423728 5.07478L2.13123 4.24928C3.46532 3.60441 5.06769 4.20911 5.64288 5.57492L10.0329 16.0004C10.5635 17.2604 12.0215 17.8421 13.2731 17.2936L19.0998 14.7415C19.4792 14.5753 19.9215 14.7482 20.0877 15.1276C20.2538 15.507 20.081 15.9493 19.7016 16.1155L13.8752 18.6674C13.0897 19.0117 12.2539 19.0798 11.4755 18.9149C11.4918 19.0243 11.5002 19.1362 11.5002 19.25C11.5002 20.4927 10.4929 21.5 9.25024 21.5C8.0076 21.5 7.00024 20.4927 7.00024 19.25C7.00024 18.1357 7.81021 17.2107 8.87349 17.0314C8.79086 16.8885 8.71624 16.7388 8.65047 16.5826L4.26047 6.1571C4.01865 5.58294 3.34496 5.32867 2.78407 5.59976ZM9.25024 18.5C8.83603 18.5 8.50024 18.8358 8.50024 19.25C8.50024 19.6642 8.83603 20 9.25024 20C9.66446 20 10.0002 19.6642 10.0002 19.25C10.0002 18.8358 9.66446 18.5 9.25024 18.5Z"
      fill={color2}
    />
  </svg>
);

const DeliveryMultiIcon = ({
  width = "24",
  height = "24",
  color1 = "#15C989",
  color2 = "#1D2540",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.1 19.5H4.65C3.45 19.5 2.5 18.55 2.5 17.35V8.05C2.5 7.2 3.2 6.5 4.05 6.5H15C15.85 6.5 16.55 7.2 16.55 8.05V10H20C20.6 10 21.15 10.35 21.4 10.9L22.85 14.2C22.95 14.4 23 14.6 23 14.85V18C23 18.85 22.3 19.55 21.45 19.55H20.7274C20.5815 20.509 19.7481 21.25 18.75 21.25C17.7519 21.25 16.9185 20.509 16.7726 19.55H15.5L16 19.5H9.25H5.1Z"
      fill={color1}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 4C16 1.792 17.792 0 20 0C22.208 0 24 1.792 24 4C24 6.17083 22.2678 7.93956 20.1111 7.99848C20.1826 8.1116 20.244 8.23336 20.2935 8.36328L21.7776 11.6282C21.9192 11.9161 22 12.2255 22 12.55V15.75C22 17.0142 21.0142 18 19.75 18H19.3957C19.0677 19.1519 18.0044 20 16.75 20C15.4956 20 14.4323 19.1519 14.1043 18H8.65967V19.1916L8.68378 19.1675C8.97667 18.8746 9.45155 18.8746 9.74444 19.1675C10.0373 19.4604 10.0373 19.9353 9.74444 20.2282L8.43994 21.5327C8.29929 21.6733 8.10852 21.7523 7.90961 21.7523C7.7107 21.7523 7.51993 21.6733 7.37928 21.5327L6.07478 20.2282C5.78189 19.9353 5.78189 19.4604 6.07478 19.1675C6.36768 18.8746 6.84255 18.8746 7.13544 19.1675L7.15967 19.1917L7.15967 12.0028C7.15967 11.5886 7.49545 11.2528 7.90967 11.2528C8.32388 11.2528 8.65967 11.5886 8.65967 12.0028V16.5H13.5066C13.5023 16.4673 13.5 16.4339 13.5 16.4V6.25C13.5 5.81421 13.1858 5.5 12.75 5.5H2.25C1.81421 5.5 1.5 5.81421 1.5 6.25V9.65C1.5 10.0642 1.16421 10.4 0.75 10.4C0.335786 10.4 0 10.0642 0 9.65V6.25C0 4.98579 0.985786 4 2.25 4H12.75C14.0142 4 15 4.98579 15 6.25V7H17.3551C16.5243 6.26687 16 5.19429 16 4ZM20.3953 2.20313C20.3953 1.87193 20.1265 1.60313 19.7953 1.60313C19.4641 1.60313 19.1953 1.87193 19.1953 2.20313V4.20312C19.1953 4.36232 19.2591 4.51376 19.3719 4.62656L20.1719 5.42656C20.2887 5.54416 20.4417 5.60312 20.5953 5.60312C20.7489 5.60312 20.9019 5.54336 21.0187 5.42656C21.2531 5.19216 21.2531 4.81332 21.0187 4.57812L20.3953 3.95313V2.20313ZM15 15.1316C15.4761 14.7374 16.0863 14.5 16.75 14.5C18.0044 14.5 19.0677 15.3481 19.3957 16.5H19.75C20.1858 16.5 20.5 16.1858 20.5 15.75V12.55C20.5 12.5341 20.4992 12.5175 20.4972 12.5H16.6001C16.1859 12.5 15.8501 12.1642 15.8501 11.75C15.8501 11.3358 16.1859 11 16.6001 11H19.8443L18.9172 8.96035C18.9092 8.94263 18.9018 8.9246 18.8952 8.90631C18.8148 8.6854 18.5709 8.5 18.25 8.5H15V15.1316ZM1.5 12.5C1.5 12.0858 1.16421 11.75 0.75 11.75C0.335786 11.75 0 12.0858 0 12.5V15.75C0 17.0142 0.985786 18 2.25 18H3.25C3.66421 18 4 17.6642 4 17.25C4 16.8358 3.66421 16.5 3.25 16.5H2.25C1.81421 16.5 1.5 16.1858 1.5 15.75V12.5ZM15.5 17.25C15.5 16.5642 16.0642 16 16.75 16C17.4358 16 18 16.5642 18 17.25C18 17.9358 17.4358 18.5 16.75 18.5C16.0642 18.5 15.5 17.9358 15.5 17.25Z"
      fill={color2}
    />
  </svg>
);

const RecoveryAndTransferIcon = ({
  color = "#DC2DFF",
  color1 = "#DC2DFF80",
  color2 = "#1D2540",
  width = "56",
  height = "56",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9591_48842)">
      <path d="M21.0004 48.738C31.4791 48.738 39.9739 40.2433 39.9739 29.7645C39.9739 19.2857 31.4791 10.791 21.0004 10.791C10.5216 10.791 2.02686 19.2857 2.02686 29.7645C2.02686 40.2433 10.5216 48.738 21.0004 48.738Z" fill={color}/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4268 28.2837C17.763 29.0023 17.4113 29.8392 16.6413 30.153L9.44042 33.0873C8.99269 33.2697 8.47833 33.2404 8.05774 33.0084L3.59521 30.5474L3.58827 30.5436C3.58827 30.5436 3.58837 30.5436 3.58827 30.5436C3.58814 30.5438 3.54297 30.523 3.43358 30.5189C3.34809 30.5158 3.24921 30.5242 3.14773 30.5455C3.09008 30.589 3.06331 30.6377 3.05129 30.6803C3.03399 30.7416 3.03932 30.8197 3.09943 30.9039C3.10448 30.9109 3.10947 30.918 3.11438 30.9252L5.65263 34.6207C6.66017 36.0983 8.59421 36.6528 10.365 35.9698L28.2019 28.6869C28.9716 28.3726 29.8686 28.7002 30.2054 29.4186C30.5422 30.137 30.1912 30.9741 29.4214 31.2884L11.5713 38.5768C11.5631 38.5801 11.5549 38.5834 11.5466 38.5866C8.45311 39.7896 4.91763 38.8297 3.08713 36.1473L0.559183 32.4669C-0.54152 30.911 0.0291497 28.8164 1.86321 27.9605C1.9276 27.9305 1.99419 27.9047 2.06248 27.8835C2.933 27.6127 4.13718 27.5419 5.14673 28.1047L8.93587 30.1944L15.4238 27.5506C16.1938 27.2369 17.0906 27.5651 17.4268 28.2837Z" fill={color2}/>
      <path d="M48.4224 25.9108C48.7456 26.2632 49.2951 26.2632 49.6182 25.9108C50.6519 24.7827 52.8091 22.3688 54.3374 20.2432C55.3874 18.7837 55.9917 17.5598 56.0361 15.9697C56.1306 12.64 53.7937 9.59732 50.5329 8.91599C45.9957 7.96865 41.9999 11.4057 41.9999 15.7772C41.9999 17.463 42.6089 18.7253 43.7009 20.2443C45.2315 22.3688 47.3887 24.7827 48.4224 25.9108Z" fill={color1}/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.50286 16.1624C7.55113 15.6334 8.67607 15.6334 9.72434 16.1624C9.73574 16.1682 9.74707 16.1741 9.75832 16.1801L23.7681 23.6961L33.0299 19.648C33.0308 19.6476 33.0318 19.6472 33.0327 19.6468C35.4475 18.5821 38.2004 19.66 39.2598 22.1043C40.3166 24.5426 39.2488 27.3232 36.8265 28.3929C36.817 28.3971 36.8076 28.4012 36.7981 28.4051L33.8244 29.6472C33.0394 29.9751 32.1398 29.5986 31.815 28.8062C31.4902 28.0139 31.8632 27.1058 32.6481 26.7779L35.6054 25.5427C36.4559 25.1598 36.8185 24.2188 36.4415 23.3489C36.0656 22.4818 35.1287 22.1106 34.2629 22.4929L34.2576 22.4953L24.3111 26.8426C23.8817 27.0303 23.3912 27.0105 22.978 26.7889L8.33482 18.933C8.18215 18.8583 8.08276 18.851 7.94058 18.911C7.8457 18.9841 7.77722 19.0957 7.75439 19.2196C7.73133 19.3447 7.75983 19.4397 7.82049 19.513L12.0075 24.0488C12.5866 24.6762 12.5523 25.6587 11.9308 26.2432C11.3093 26.8278 10.336 26.7931 9.75692 26.1658L5.55272 21.6114C5.54451 21.6025 5.53641 21.5935 5.52841 21.5844C4.00034 19.8491 4.63719 17.2871 6.39937 16.2198C6.43312 16.1993 6.46765 16.1802 6.50286 16.1624Z" fill={color2}/>
      <path d="M46.3816 3.81445C46.3816 2.84796 45.5981 2.06445 44.6316 2.06445C40.6077 2.06445 37.9403 4.4885 36.6929 7.25043C36.0758 8.61697 35.7824 10.1036 35.8278 11.5002C35.8727 12.8802 36.2559 14.3024 37.1401 15.4077C39.0112 17.7466 42.0092 21.4455 43.2734 23.0013C43.6044 23.4087 44.1008 23.646 44.6258 23.6478C45.1507 23.6495 45.6487 23.4155 45.9825 23.0103C47.3423 21.359 50.4876 17.5107 52.1379 15.3888C54.2812 12.6333 54.0808 9.15335 52.101 6.77748C51.4822 6.03498 50.3788 5.93466 49.6363 6.55339C48.8938 7.17212 48.7934 8.27561 49.4122 9.0181C50.3489 10.1422 50.4987 11.7956 49.3752 13.2401C48.1784 14.7789 46.1593 17.2688 44.6388 19.1292C43.1881 17.3392 41.2307 14.9182 39.8731 13.2212C39.5906 12.8682 39.354 12.2487 39.326 11.3865C39.2985 10.5409 39.479 9.58485 39.8827 8.69098C40.6771 6.93207 42.2387 5.56445 44.6316 5.56445C45.5981 5.56445 46.3816 4.78095 46.3816 3.81445Z" fill={color2}/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M43.0914 7.46374C43.7748 6.78032 44.8829 6.78032 45.5663 7.46373L47.904 9.73476C48.2322 10.063 48.4165 10.5081 48.4165 10.9722C48.4165 11.4363 48.2322 11.8815 47.904 12.2096L45.5666 14.6845C44.8832 15.3679 43.7752 15.3679 43.0918 14.6845C42.4083 14.0011 42.4083 12.8931 43.0918 12.2096L44.1917 10.9722L43.0914 9.93861C42.408 9.25519 42.408 8.14715 43.0914 7.46374Z" fill={color2}/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M45.5709 28.2098C44.8874 27.5264 43.7794 27.5264 43.096 28.2098L38.4293 32.8765C37.7459 33.5599 37.7459 34.668 38.4293 35.3514C39.1127 36.0348 40.2208 36.0348 40.9042 35.3514L42.5146 33.741C41.6815 43.6038 33.4119 51.3491 23.3336 51.3491C20.4791 51.3491 17.7757 50.7266 15.3465 49.6135C14.4678 49.2109 13.4291 49.5968 13.0265 50.4754C12.6239 51.3541 13.0098 52.3927 13.8884 52.7954C16.7652 54.1136 19.9651 54.8491 23.3336 54.8491C35.3861 54.8491 45.2498 45.4764 46.0334 33.6222L47.7626 35.3514C48.4461 36.0348 49.5541 36.0348 50.2375 35.3514C50.9209 34.668 50.9209 33.5599 50.2375 32.8765L45.5709 28.2098ZM5.17203 42.7606C5.9617 42.2034 7.0536 42.3918 7.61087 43.1814C8.33959 44.2141 9.16667 45.1716 10.0792 46.0403C10.7792 46.7067 10.8065 47.8144 10.1401 48.5144C9.47369 49.2144 8.36599 49.2417 7.66595 48.5753C6.5881 47.5493 5.61151 46.4185 4.75124 45.1995C4.19397 44.4098 4.38237 43.3179 5.17203 42.7606Z" fill={color2}/>
    </g>
    <defs>
      <clipPath id="clip0_9591_48842">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const RecoveryAndDeliveryIcon = ({
  color = "#2DB5FF80",
  color1 = "#2DB5FF",
  color2 = "#1D2540",
  width = "56",
  height = "56",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_53_2334)">
      <path
        d="M18.9735 46.9743C8.49475 46.9743 1.90735e-05 38.4796 1.90735e-05 28.0008C1.90735e-05 17.5221 8.49475 9.02734 18.9735 9.02734C29.4523 9.02734 37.947 17.5221 37.947 28.0008C37.947 38.4796 29.4523 46.9743 18.9735 46.9743Z"
        fill={color}
      />
      <path
        d="M48.4224 54.4792C48.7456 54.8315 49.2951 54.8315 49.6182 54.4792C50.6519 53.351 52.8091 50.9372 54.3374 48.8115C55.3874 47.352 55.9917 46.1282 56.0361 44.538C56.1306 41.2083 53.7937 38.1657 50.5329 37.4843C45.9957 36.537 41.9999 39.974 41.9999 44.3455C41.9999 46.0313 42.6089 47.2937 43.7009 48.8127C45.2315 50.9372 47.3887 53.351 48.4224 54.4792Z"
        fill={color1}
      />
      <path
        d="M46.3399 21.8111C45.5564 9.95683 35.6926 0.583984 23.64 0.583984C20.2891 0.583984 17.1057 1.31197 14.2394 2.61737C13.3598 3.01796 12.9715 4.05573 13.3721 4.9353C13.7727 5.81488 14.8104 6.20318 15.69 5.8026C18.111 4.7 20.8006 4.08398 23.64 4.08398C33.7183 4.08398 41.9878 11.8292 42.821 21.6919L41.2108 20.0817C40.5274 19.3983 39.4193 19.3983 38.7359 20.0817C38.0525 20.7651 38.0525 21.8732 38.7359 22.5566L43.4026 27.2233C44.086 27.9067 45.1941 27.9067 45.8775 27.2233L50.5441 22.5566C51.2276 21.8732 51.2276 20.7651 50.5441 20.0817C49.8607 19.3983 48.7527 19.3983 48.0693 20.0817L46.3399 21.8111Z"
        fill={color2}
      />
      <path
        d="M10.7702 6.6619C10.1173 5.94929 9.01035 5.9009 8.29774 6.55382C7.09157 7.65895 6.00405 8.89295 5.05779 10.2334C4.5004 11.0229 4.68863 12.1149 5.4782 12.6723C6.26778 13.2297 7.35972 13.0414 7.91711 12.2519C8.71852 11.1166 9.64 10.071 10.6622 9.13442C11.3748 8.4815 11.4232 7.37452 10.7702 6.6619Z"
        fill={color2}
      />
      <path
        d="M17.7332 14.0835C19.025 14.2864 19.9115 15.1647 20.2621 16.1366L25.2155 29.2157L34.4045 32.0963C36.929 32.8104 38.2351 35.3284 37.3784 37.6523C36.6258 39.8689 33.9904 41.2539 31.4658 40.4241L28.4753 39.4866C27.6889 39.2401 27.2639 38.4408 27.526 37.7012C27.7882 36.9617 28.6381 36.562 29.4245 36.8085L32.4263 37.7495L32.4512 37.7575C33.3152 38.0443 34.2636 37.5618 34.5215 36.7855C34.527 36.7692 34.5327 36.7529 34.5388 36.7368C34.8616 35.8765 34.3798 35.0319 33.5294 34.7967C33.5123 34.792 33.4952 34.7869 33.4783 34.7816L23.5724 31.6763C23.1344 31.539 22.788 31.2198 22.6331 30.8108L17.43 17.0722L17.42 17.045C17.3979 16.9826 17.3626 16.9367 17.3303 16.9095C17.3033 16.8868 17.2744 16.8726 17.2308 16.8668C17.1797 16.8599 17.1291 16.8506 17.079 16.8388C16.949 16.8082 16.861 16.8382 16.7962 16.8884C16.7288 16.9406 16.6449 17.0512 16.6426 17.2489L16.7424 23.0688C16.7558 23.8482 16.0947 24.4903 15.2659 24.5029C14.4371 24.5154 13.7544 23.8938 13.741 23.1143L13.641 17.2801L13.6408 17.2574C13.6408 15.2189 15.5352 13.6119 17.7332 14.0835Z"
        fill={color2}
      />
      <path
        d="M48.7149 32.084C48.7149 31.1175 47.9314 30.334 46.9649 30.334C42.9411 30.334 40.2736 32.758 39.0263 35.52C38.4091 36.8865 38.1157 38.3731 38.1611 39.7698C38.206 41.1497 38.5892 42.572 39.4734 43.6772C41.3445 46.0161 44.3426 49.715 45.6067 51.2709C45.9377 51.6783 46.4342 51.9156 46.9591 51.9173C47.4841 51.919 47.9821 51.685 48.3158 51.2798C49.6756 49.6286 52.8209 45.7803 54.4713 43.6584C56.6145 40.9028 56.4142 37.4229 54.4343 35.047C53.8156 34.3045 52.7121 34.2042 51.9696 34.8229C51.2271 35.4417 51.1268 36.5451 51.7455 37.2876C52.6823 38.4118 52.832 40.0651 51.7085 41.5096C50.5117 43.0484 48.4927 45.5383 46.9722 47.3988C45.5214 45.6087 43.564 43.1877 42.2064 41.4908C41.924 41.1377 41.6873 40.5182 41.6593 39.656C41.6318 38.8105 41.8124 37.8544 42.2161 36.9605C43.0104 35.2016 44.5721 33.834 46.9649 33.834C47.9314 33.834 48.7149 33.0505 48.7149 32.084Z"
        fill={color2}
      />
      <path
        d="M47.269 41.4371C45.9804 41.4371 44.9357 40.3924 44.9357 39.1038C44.9357 37.8151 45.9804 36.7705 47.269 36.7705C48.5577 36.7705 49.6024 37.8151 49.6024 39.1038C49.6024 40.3924 48.5577 41.4371 47.269 41.4371Z"
        fill={color2}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.9544 16.7733C6.08722 17.0083 6.88055 17.9653 7.18836 18.9502L7.19105 18.9589L8.46294 23.1133L15.3403 25.5584C16.0724 25.8186 16.468 26.6626 16.224 27.4434C15.98 28.2243 15.1887 28.6462 14.4566 28.386L6.91136 25.7035C6.49127 25.5541 6.16242 25.2012 6.02497 24.7523L4.53637 19.89C4.51477 19.8225 4.47657 19.7617 4.43765 19.7225C4.4231 19.7079 4.41256 19.7001 4.40686 19.6964C4.36558 19.6886 4.32465 19.6788 4.28419 19.667C4.16014 19.6309 4.08804 19.6595 4.04127 19.6928C3.9873 19.7311 3.91431 19.8171 3.88512 19.9802L3.14362 24.6265C2.87777 26.5033 3.89235 28.2679 5.54344 28.8314L5.55527 28.8355L23.3471 35.0947C24.08 35.3525 24.4781 36.1951 24.2364 36.9767C23.9947 37.7584 23.2046 38.183 22.4718 37.9252L4.68544 31.668C1.68596 30.6407 -0.090447 27.4456 0.38313 24.1624C0.38426 24.1546 0.385447 24.1468 0.386694 24.139L1.1319 19.4694L1.13463 19.4529C1.451 17.5971 3.09836 16.2747 4.9544 16.7733Z"
        fill={color2}
      />
    </g>
    <defs>
      <clipPath id="clip0_5919_34183">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SaveAndSearchIcon = ({
  width = "56",
  height = "56",
  color1 = "#FFBA07",
  color2 = "#1D2540",
}) => (
  <svg
    viewBox="0 0 56 56"
    focusable="false"
    data-icon="assign"
    width={width}
    height={height}
    // fill={color}
    aria-hidden="true"
  >
    <path
      d="M5.83325 12.25C5.83325 11.2835 6.61675 10.5 7.58325 10.5H48.4166C49.3831 10.5 50.1666 11.2835 50.1666 12.25C50.1666 13.2165 49.3831 14 48.4166 14H7.58325C6.61675 14 5.83325 13.2165 5.83325 12.25Z"
      fill={color2}
    />
    <path
      d="M39.9657 28.8771C39.7123 28.3703 39.0061 28.3703 38.7527 28.8771L38.7479 28.8867L36.2977 33.7129C35.7996 34.8137 34.8173 35.4383 33.7792 35.5906L27.5741 36.5621L27.5699 36.5628C27.0116 36.6488 26.8041 37.3248 27.1934 37.7141L31.3321 41.8528C32.2491 42.6469 32.4609 43.8244 32.3306 44.7389L32.3275 44.7595L31.3549 51.048C31.3548 51.0482 31.3549 51.0478 31.3549 51.048C31.3179 51.2903 31.4117 51.4996 31.6242 51.647C31.8453 51.8002 32.1063 51.8217 32.3355 51.7021C33.1924 51.2551 34.2495 51.5873 34.6965 52.4442C35.1435 53.3012 34.8112 54.3582 33.9543 54.8052C31.0299 56.3309 27.3676 53.9576 27.8953 50.5173L28.8533 44.3238L24.7185 40.1889C22.2617 37.7321 23.7026 33.6192 27.0345 33.1039C27.0353 33.1038 27.0361 33.1037 27.0369 33.1036L33.1693 32.1435L35.6249 27.3065C37.1696 24.2272 41.5487 24.2272 43.0934 27.3064L43.4704 28.0488C43.908 28.9106 43.5642 29.9639 42.7024 30.4015C41.8407 30.8391 40.7874 30.4953 40.3497 29.6335L39.9706 28.8869L39.9657 28.8771ZM28.8667 44.2293C28.8667 44.2282 28.8667 44.2293 28.8667 44.2293V44.2293Z"
      fill={color2}
    />
    <path
      d="M43.4723 33.5883C43.6218 32.6334 44.5171 31.9806 45.4719 32.1301L51.6824 33.1024C51.6833 33.1025 51.6841 33.1026 51.6849 33.1028C55.1159 33.633 56.2898 37.7751 54.0334 40.1545C54.0192 40.1695 54.0047 40.1843 53.9899 40.1988L49.7905 44.3236L50.7482 50.5152C51.2613 53.8473 47.7788 56.4694 44.6743 54.7962L39.3567 51.9895C38.4999 52.3945 37.4721 52.0429 37.0452 51.1912C36.612 50.3272 36.9613 49.2757 37.8253 48.8426C38.7681 48.37 39.9491 48.37 40.8918 48.8426C40.9028 48.848 40.9136 48.8536 40.9244 48.8593L46.3156 51.7048L46.3325 51.7139C46.8212 51.9787 47.3748 51.6069 47.289 51.0482C47.289 51.0481 47.289 51.0483 47.289 51.0482L46.3174 44.7661C46.1549 43.7649 46.4849 42.6783 47.2573 41.9059L47.2685 41.8949L51.509 37.7297C51.695 37.5224 51.7402 37.2559 51.6599 37.0064C51.5803 36.7591 51.405 36.6009 51.1498 36.5616L51.1454 36.5609L44.9306 35.5879C43.9757 35.4384 43.3228 34.5432 43.4723 33.5883Z"
      fill={color2}
    />
    <path
      d="M5.83325 28C5.83325 27.0335 6.61675 26.25 7.58325 26.25H30.9166C31.8831 26.25 32.6666 27.0335 32.6666 28C32.6666 28.9665 31.8831 29.75 30.9166 29.75H7.58325C6.61675 29.75 5.83325 28.9665 5.83325 28Z"
      fill={color2}
    />
    <path
      d="M5.83325 43.75C5.83325 42.7835 6.61675 42 7.58325 42H20.4166C21.3831 42 22.1666 42.7835 22.1666 43.75C22.1666 44.7165 21.3831 45.5 20.4166 45.5H7.58325C6.61675 45.5 5.83325 44.7165 5.83325 43.75Z"
      fill={color2}
    />
  </svg>
);

const RecoveryIcon_v2 = ({ width = "24", height = "24", color = "#1A354D" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      transform="translate(6.5 5.05)"
      d="M15 7.5C15 3.35 11.65 0 7.5 0C3.35 0 0 3.35 0 7.5C0 9.35 0.7 11.05 1.8 12.35C1.8 12.35 5.35 16.4 6.5 17.5C7.05 18.05 7.95 18.05 8.5 17.5C9.85 16.25 13.2 12.35 13.2 12.35C14.3 11.05 15 9.35 15 7.5Z"
      fill="#8295F5"
    />
    <path
      transform="translate(3.5 1.95)"
      d="M0.75 7.5498C1.16415 7.5498 1.4999 7.88568 1.5 8.2998V8.5498C1.50006 10.2562 2.12671 11.8377 3.17188 13.1143L3.2041 13.1514C3.23134 13.1822 3.27179 13.2279 3.32324 13.2861C3.42632 13.4027 3.57503 13.5706 3.75684 13.7754C4.12093 14.1855 4.61851 14.7439 5.15137 15.3359C6.22283 16.5264 7.40897 17.8214 7.96191 18.3516C8.28766 18.6455 8.72594 18.6135 8.96973 18.3701C8.9892 18.3506 9.00976 18.3317 9.03125 18.3145C9.213 18.1691 9.46066 17.8846 9.78027 17.5117C10.0498 17.1972 10.5234 17.1612 10.8379 17.4307C11.1522 17.7002 11.1893 18.1738 10.9199 18.4883C10.9094 18.5005 10.8984 18.5129 10.8877 18.5254C10.6224 18.8351 10.2975 19.2138 10 19.46C9.14364 20.2841 7.80667 20.2442 6.94336 19.4531C6.93957 19.4496 6.93537 19.4459 6.93164 19.4424C6.33177 18.8686 5.09778 17.5185 4.03613 16.3389C3.50045 15.7437 3.00028 15.1832 2.63477 14.7715C2.45208 14.5657 2.30291 14.3966 2.19922 14.2793C2.14746 14.2207 2.10661 14.1747 2.0791 14.1436L2.03711 14.0957C2.0315 14.0893 2.02589 14.0827 2.02051 14.0762C0.770624 12.5546 6.0031e-05 10.6389 0 8.5498V8.2998C9.89401e-05 7.88568 0.335847 7.5498 0.75 7.5498ZM8.5 0C13.2142 0 17 3.78579 17 8.5C16.9999 10.6345 16.2321 12.5554 14.9707 14.0361L14.9648 14.0439L14.9473 14.0635C14.9364 14.0758 14.9207 14.0941 14.9004 14.1172C14.8591 14.164 14.7983 14.2323 14.7227 14.3174C14.5712 14.4878 14.3574 14.7277 14.1055 15.0049C13.8269 15.3112 13.3524 15.3331 13.0459 15.0547C12.7394 14.7761 12.7166 14.3016 12.9951 13.9951C13.2427 13.7228 13.4531 13.4873 13.6016 13.3203C13.6757 13.2369 13.7354 13.1704 13.7754 13.125C13.789 13.1096 13.8004 13.0963 13.8096 13.0859C13.8135 13.0815 13.8173 13.0767 13.8203 13.0732L13.832 13.0596C14.8686 11.8409 15.4999 10.2635 15.5 8.5C15.5 4.61421 12.3858 1.5 8.5 1.5C6.77849 1.50001 5.2506 2.08655 4.03613 3.12109C3.72088 3.3893 3.24802 3.35115 2.97949 3.03613C2.71102 2.72097 2.74859 2.24817 3.06348 1.97949C4.54898 0.714062 6.42156 1.45166e-05 8.5 0ZM11.7666 4.00684C12.1771 3.99427 12.5154 4.33106 12.5186 4.74414L12.5312 6.75684C12.5332 7.17015 12.1993 7.50737 11.7881 7.52148L9.77148 7.52344C9.3609 7.53616 9.02182 7.20023 9.01855 6.78711C9.01659 6.37368 9.35068 6.03559 9.76562 6.03516L9.97656 6.03223C9.96088 6.02313 9.94541 6.01322 9.93066 6.00391C8.49902 5.17341 6.66841 5.66462 5.84375 7.09961C5.01683 8.52211 5.51105 10.3642 6.93848 11.1826C8.37012 12.0129 10.2008 11.5219 11.0254 10.0869C11.2316 9.72839 11.691 9.60546 12.0498 9.8125C12.4087 10.0207 12.5333 10.485 12.3262 10.8438C11.0859 12.9845 8.33434 13.7213 6.18945 12.4854C4.04088 11.239 3.30448 8.49544 4.54199 6.3418C5.78212 4.20125 8.53344 3.46466 10.6777 4.69824C10.7981 4.77672 10.9098 4.84399 11.0215 4.9248L11.0195 4.75879C11.0176 4.34542 11.3517 4.00732 11.7666 4.00684Z"
      fill={color}
    />
  </svg>
);

const RecoveryTransferTransIcon = ({ width = "24", height = "24", color = "#1A354D" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      transform="translate(6.5 5.05)"
      d="M15 7.5C15 3.35 11.65 0 7.5 0C3.35 0 0 3.35 0 7.5C0 9.35 0.7 11.05 1.8 12.35C1.8 12.35 5.35 16.4 6.5 17.5C7.05 18.05 7.95 18.05 8.5 17.5C9.85 16.25 13.2 12.35 13.2 12.35C14.3 11.05 15 9.35 15 7.5Z"
      fill="#FFBA07"
    />
    <path
      transform="translate(3.5 1.95)"
      d="M0.75 7.5498C1.16415 7.5498 1.4999 7.88568 1.5 8.2998V8.5498C1.5 10.2562 2.12666 11.8376 3.17188 13.1143L3.2041 13.1514C3.23134 13.1822 3.27171 13.2278 3.32324 13.2861C3.42633 13.4027 3.57496 13.5705 3.75684 13.7754C4.12094 14.1855 4.61845 14.7438 5.15137 15.3359C6.22286 16.5265 7.40894 17.8214 7.96191 18.3516C8.28773 18.6457 8.72593 18.6137 8.96973 18.3701C8.98923 18.3506 9.00971 18.3317 9.03125 18.3145C9.21302 18.169 9.4606 17.8847 9.78027 17.5117C10.0498 17.1972 10.5234 17.1612 10.8379 17.4307C11.1523 17.7002 11.1894 18.1738 10.9199 18.4883C10.9094 18.5006 10.8984 18.5129 10.8877 18.5254C10.6224 18.8351 10.2976 19.2138 10 19.46C9.1436 20.2843 7.8067 20.2443 6.94336 19.4531C6.93953 19.4496 6.9354 19.446 6.93164 19.4424C6.33175 18.8686 5.09781 17.5185 4.03613 16.3389C3.50039 15.7436 3.00029 15.1832 2.63477 14.7715C2.45201 14.5656 2.30292 14.3966 2.19922 14.2793C2.14738 14.2207 2.10661 14.1747 2.0791 14.1436L2.03711 14.0957C2.03146 14.0893 2.02593 14.0828 2.02051 14.0762C0.770576 12.5545 0 10.639 0 8.5498V8.2998C9.89401e-05 7.88568 0.335847 7.5498 0.75 7.5498ZM8.5 0C13.2142 0 17 3.78579 17 8.5C17 10.6346 16.2321 12.5553 14.9707 14.0361L14.9648 14.0439L14.9473 14.0635C14.9364 14.0758 14.9208 14.094 14.9004 14.1172C14.8591 14.164 14.7984 14.2322 14.7227 14.3174C14.5712 14.4878 14.3575 14.7277 14.1055 15.0049C13.8269 15.3114 13.3524 15.3333 13.0459 15.0547C12.7394 14.7761 12.7165 14.3016 12.9951 13.9951C13.2427 13.7227 13.4531 13.4873 13.6016 13.3203C13.6758 13.2368 13.7354 13.1704 13.7754 13.125C13.7891 13.1095 13.8004 13.0963 13.8096 13.0859C13.8135 13.0814 13.8172 13.0767 13.8203 13.0732L13.832 13.0596C14.8687 11.8409 15.5 10.2636 15.5 8.5C15.5 4.61421 12.3858 1.5 8.5 1.5C6.77849 1.50001 5.2506 2.08655 4.03613 3.12109C3.72083 3.38946 3.24803 3.35132 2.97949 3.03613C2.71099 2.72093 2.74848 2.24815 3.06348 1.97949C4.54898 0.714062 6.42156 1.45162e-05 8.5 0ZM8.71973 5.26953C9.01259 4.9768 9.48741 4.9768 9.78027 5.26953L12.2803 7.76953C12.5731 8.06238 12.573 8.53718 12.2803 8.83008L9.78027 11.3301C9.48738 11.623 9.01262 11.623 8.71973 11.3301C8.42696 11.0372 8.42687 10.5624 8.71973 10.2695L9.93945 9.0498H5.25C4.83579 9.0498 4.5 8.71402 4.5 8.2998C4.50013 7.8857 4.83587 7.5498 5.25 7.5498H9.93945L8.71973 6.33008C8.42696 6.03718 8.42687 5.56238 8.71973 5.26953Z"
      fill={color}
    />
  </svg>
);

const CrossDockDropoff = ({
  width = 24,
  height = 24,
  color1 = "#AABDCD",
  color2 = "#1D2540",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 16.06V20.44C21.5 21.58 20.575 22.5 19.44 22.5H8.56C7.425 22.5 6.5 21.575 6.5 20.44V7.56C6.5 6.42 7.425 5.5 8.56 5.5H19.44C20.58 5.5 21.5 6.425 21.5 7.56V11.94V16.06Z"
        fill={color1}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 5.75C5.25 5.05921 5.80921 4.5 6.5 4.5H17.5C18.1908 4.5 18.75 5.05921 18.75 5.75V9.63C18.75 10.0442 19.0858 10.38 19.5 10.38C19.9142 10.38 20.25 10.0442 20.25 9.63V5.75C20.25 4.23079 19.0192 3 17.5 3H6.5C4.98079 3 3.75 4.23079 3.75 5.75V14C3.75 14.4142 4.08579 14.75 4.5 14.75C4.91421 14.75 5.25 14.4142 5.25 14V5.75ZM20.25 14C20.25 13.5858 19.9142 13.25 19.5 13.25C19.0858 13.25 18.75 13.5858 18.75 14V18.25C18.75 18.9408 18.1908 19.5 17.5 19.5H6.5C5.80921 19.5 5.25 18.9408 5.25 18.25V17.065C5.25 16.6508 4.91421 16.315 4.5 16.315C4.08579 16.315 3.75 16.6508 3.75 17.065V18.25C3.75 19.7692 4.98079 21 6.5 21H17.5C19.0192 21 20.25 19.7692 20.25 18.25V14Z"
        fill={color2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 7.75C12.75 7.33579 12.4142 7 12 7C11.5858 7 11.25 7.33579 11.25 7.75L11.25 13.1893L10.5303 12.4697C10.2374 12.1768 9.76256 12.1768 9.46967 12.4697C9.17678 12.7626 9.17678 13.2374 9.46967 13.5303L11.4697 15.5303C11.7626 15.8232 12.2374 15.8232 12.5303 15.5303L14.5303 13.5303C14.8232 13.2374 14.8232 12.7626 14.5303 12.4697C14.2374 12.1768 13.7626 12.1768 13.4697 12.4697L12.75 13.1893L12.75 7.75Z"
        fill={color2}
      />
    </svg>
  );
};

const SameDay= ({
  width = 24,
  height = 24,
  color1 = "#FFBA07",
  color2 = "#1D2540",
}) => {
  return (

<svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9408 20.6018C12.71 20.8534 12.3175 20.8534 12.0866 20.6018C11.3483 19.7959 9.80746 18.0718 8.7158 16.5534C7.9658 15.5109 7.53413 14.6368 7.50246 13.5009C7.43496 11.1226 9.10413 8.94926 11.4333 8.46259C14.6741 7.78592 17.5283 10.2409 17.5283 13.3634C17.5283 14.5676 17.0933 15.4693 16.3133 16.5543C15.22 18.0718 13.6791 19.7959 12.9408 20.6018Z" fill="#5064AE"/>
<path d="M34.559 28.9143C34.3281 29.1659 33.9356 29.1659 33.7048 28.9143C32.9665 28.1084 31.4256 26.3843 30.334 24.8659C29.584 23.8234 29.1523 22.9493 29.1206 21.8134C29.0531 19.4351 30.7223 17.2618 33.0515 16.7751C36.2923 16.0984 39.1465 18.5534 39.1465 21.6759C39.1465 22.8801 38.7115 23.7818 37.9315 24.8668C36.8381 26.3843 35.2973 28.1084 34.559 28.9143Z" fill="#5064AE" fill-opacity="0.5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.58319 2.91602C8.89283 2.91602 8.33319 3.47566 8.33319 4.16602C8.33319 4.85637 8.89283 5.41602 9.58319 5.41602C11.2924 5.41602 12.4078 6.39289 12.9752 7.64925C13.2636 8.28773 13.3926 8.97065 13.3729 9.57461C13.3529 10.1905 13.1839 10.6329 12.9821 10.8851C12.0124 12.0973 10.6143 13.8265 9.578 15.1051C8.49193 13.7763 7.04976 11.9977 6.19488 10.8986C5.39241 9.86685 5.49936 8.68585 6.16847 7.88291C6.61042 7.35256 6.53876 6.56435 6.00841 6.1224C5.47806 5.68045 4.68986 5.75211 4.24791 6.28246C2.83372 7.97951 2.69063 10.4652 4.2215 12.4334C5.40033 13.9491 7.64696 16.6979 8.61827 17.8773C8.85664 18.1668 9.21235 18.3339 9.58732 18.3327C9.96228 18.3314 10.3169 18.1619 10.5533 17.8709C11.4563 16.7596 13.5977 14.1175 14.9343 12.4469C15.5658 11.6574 15.8395 10.6415 15.8716 9.65586C15.904 8.65825 15.6945 7.59639 15.2537 6.62028C14.3627 4.64748 12.4574 2.91602 9.58319 2.91602ZM9.58325 11.2493C10.5037 11.2493 11.2499 10.5032 11.2499 9.58268C11.2499 8.66221 10.5037 7.91602 9.58325 7.91602C8.66278 7.91602 7.91658 8.66221 7.91658 9.58268C7.91658 10.5032 8.66278 11.2493 9.58325 11.2493ZM30.4032 19.5968C31.3236 19.5968 32.0698 18.8507 32.0698 17.9302C32.0698 17.0097 31.3236 16.2635 30.4032 16.2635C29.4827 16.2635 28.7365 17.0097 28.7365 17.9302C28.7365 18.8507 29.4827 19.5968 30.4032 19.5968ZM10.8333 22.0827C10.8333 22.773 10.2736 23.3327 9.58325 23.3327C8.8929 23.3327 8.33325 22.773 8.33325 22.0827C8.33325 21.3923 8.8929 20.8327 9.58325 20.8327C10.2736 20.8327 10.8333 21.3923 10.8333 22.0827ZM9.58325 27.4993C10.2736 27.4993 10.8333 26.9397 10.8333 26.2493C10.8333 25.559 10.2736 24.9993 9.58325 24.9993C8.8929 24.9993 8.33325 25.559 8.33325 26.2493C8.33325 26.9397 8.8929 27.4993 9.58325 27.4993ZM10.8333 30.416C10.8333 31.1064 10.2736 31.666 9.58325 31.666C8.8929 31.666 8.33325 31.1064 8.33325 30.416C8.33325 29.7257 8.8929 29.166 9.58325 29.166C10.2736 29.166 10.8333 29.7257 10.8333 30.416ZM9.58325 35.8327C10.2736 35.8327 10.8333 35.273 10.8333 34.5827C10.8333 33.8923 10.2736 33.3327 9.58325 33.3327C8.8929 33.3327 8.33325 33.8923 8.33325 34.5827C8.33325 35.273 8.8929 35.8327 9.58325 35.8327ZM31.6666 34.5827C31.6666 35.273 31.1069 35.8327 30.4166 35.8327C29.7262 35.8327 29.1666 35.273 29.1666 34.5827C29.1666 33.8923 29.7262 33.3327 30.4166 33.3327C31.1069 33.3327 31.6666 33.8923 31.6666 34.5827ZM30.4166 31.666C31.1069 31.666 31.6666 31.1064 31.6666 30.416C31.6666 29.7257 31.1069 29.166 30.4166 29.166C29.7262 29.166 29.1666 29.7257 29.1666 30.416C29.1666 31.1064 29.7262 31.666 30.4166 31.666ZM29.3704 12.916C29.3704 12.2257 29.93 11.666 30.6204 11.666C33.4945 11.666 35.3999 13.3975 36.2908 15.3703C36.7317 16.3464 36.9412 17.4083 36.9088 18.4059C36.8767 19.3915 36.603 20.4074 35.9715 21.1969C34.6349 22.8675 32.4935 25.5096 31.5905 26.6209C31.3541 26.9119 30.9995 27.0814 30.6245 27.0827C30.2495 27.0839 29.8938 26.9168 29.6555 26.6273C28.6841 25.4479 26.4375 22.6991 25.2587 21.1834C23.7278 19.2152 23.8709 16.7295 25.2851 15.0325C25.727 14.5021 26.5153 14.4304 27.0456 14.8724C27.576 15.3144 27.6476 16.1026 27.2057 16.6329C26.5366 17.4359 26.4296 18.6168 27.2321 19.6486C28.087 20.7477 29.5291 22.5263 30.6152 23.8551C31.6514 22.5765 33.0496 20.8473 34.0193 19.6351C34.2211 19.3829 34.3901 18.9405 34.4101 18.3246C34.4297 17.7207 34.3008 17.0377 34.0124 16.3992C33.445 15.1429 32.3295 14.166 30.6204 14.166C29.93 14.166 29.3704 13.6064 29.3704 12.916ZM19.9999 23.3327C15.3983 23.3327 11.6666 27.0644 11.6666 31.666C11.6666 36.2677 15.3983 39.9993 19.9999 39.9993C24.6016 39.9993 28.3333 36.2677 28.3333 31.666C28.3333 27.0644 24.6016 23.3327 19.9999 23.3327ZM24.5717 33.6555L24.0239 34.6289C23.8406 34.9551 23.4121 35.0451 23.1128 34.8205L20.8204 33.101L21.1601 35.9264C21.2043 36.2955 20.9165 36.62 20.5454 36.62H19.4551C19.084 36.62 18.7958 36.2955 18.8404 35.9269L19.1802 33.1015L16.8873 34.8205C16.588 35.0451 16.1595 34.9546 15.9762 34.6289L15.4284 33.6555C15.2439 33.3277 15.3917 32.9124 15.7421 32.7753L18.4528 31.7123L15.7203 30.5766C15.3789 30.4346 15.2368 30.0271 15.4168 29.7039L15.9667 28.7156C16.1525 28.3803 16.5955 28.2936 16.8948 28.5335L19.193 30.3764L18.8388 27.4048C18.7954 27.0362 19.0832 26.7121 19.4539 26.7121H20.5458C20.917 26.7121 21.2047 27.0362 21.1605 27.4044L20.8063 30.376L23.1045 28.5331C23.4038 28.2932 23.8468 28.3799 24.033 28.7151L24.5829 29.7035C24.7625 30.0267 24.6209 30.4342 24.2795 30.5762L21.5469 31.7119L24.2576 32.7749C24.6085 32.9124 24.7563 33.3277 24.5717 33.6555Z" fill="#1D2540"/>
</svg>
  )}


  const MultiDayPickupIcon = ({
    width = 24,
    height = 24,
    color1 = "#FFBA07",
    color2 = "#1D2540",
  }) => {
    return (
  
<svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_15598_103288)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M34.2094 20.945C33.3931 20.7521 32.5417 20.65 31.6665 20.65C27.9045 20.65 24.583 22.5358 22.5956 25.4137L19.7194 18.4725C19.3736 17.6775 19.7386 16.7542 20.5328 16.4092L29.0669 12.7009C29.8619 12.355 30.7853 12.72 31.1303 13.5142L34.2094 20.945Z" fill="#D23B71"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.3174 8.17603C16.0552 8.81464 16.3603 9.54492 16.9989 9.80718C17.6375 10.0694 18.3677 9.76434 18.63 9.12573L18.6517 9.07278L19.3623 10.7736L16.7013 11.9302C15.2786 12.5484 14.6218 14.2006 15.235 15.6271L19.0906 24.9318L19.0989 24.9513C19.5846 26.0695 20.7092 26.7146 21.8609 26.6419C22.3833 25.6246 23.0593 24.6991 23.8584 23.8962C23.5127 23.6478 23.0487 23.5823 22.6299 23.7643L21.8101 24.1204C21.6514 24.1894 21.4668 24.1188 21.3946 23.9613L17.541 14.6614L17.5325 14.6413C17.4625 14.4806 17.5361 14.2933 17.6978 14.223L20.3261 13.0806L21.9856 17.0529C22.2517 17.6899 22.9838 17.9905 23.6208 17.7244C24.2578 17.4583 24.5585 16.7262 24.2924 16.0892L20.9587 8.10943L21.0111 8.13097C21.6497 8.39322 22.38 8.08813 22.6423 7.44952C22.9045 6.81092 22.5994 6.08063 21.9608 5.81838L19.1166 4.65035C18.8099 4.52441 18.4658 4.52545 18.1599 4.65325C17.854 4.78104 17.6114 5.02512 17.4854 5.33179L16.3174 8.17603ZM16.7215 26.6673C17.4424 28.3791 19.1903 29.3397 20.9417 29.1412C20.7515 29.9518 20.6509 30.797 20.6508 31.6656C20.1352 31.6785 19.6234 31.6303 19.1258 31.5249C19.153 31.7071 19.1671 31.8935 19.1671 32.0833C19.1671 34.1544 17.4881 35.8333 15.4171 35.8333C13.346 35.8333 11.6671 34.1544 11.6671 32.0833C11.6671 30.2262 13.017 28.6844 14.7891 28.3857C14.6514 28.1475 14.5271 27.8979 14.4174 27.6376L7.10078 10.2618C6.69775 9.30486 5.57494 8.88107 4.64012 9.33289L1.79436 10.7087C1.17283 11.0092 0.425387 10.7489 0.124904 10.1274C-0.175579 9.50585 0.0846826 8.75841 0.706214 8.45792L3.55205 7.08209C5.77553 6.00731 8.44615 7.01515 9.4048 9.29149L16.7215 26.6673ZM32.8074 19.0079C33.0496 19.5715 33.0933 20.1705 32.9697 20.7271C32.5424 20.6767 32.1075 20.6508 31.6667 20.6508C30.7851 20.6508 29.9277 20.7544 29.106 20.95L30.3433 20.4125C30.506 20.3413 30.5788 20.152 30.5099 19.9935L30.5014 19.9735L26.6478 10.6736C26.5756 10.5162 26.391 10.4457 26.2323 10.5146L26.0189 10.6076C25.386 10.8834 24.6494 10.5939 24.3736 9.96104C24.0978 9.32817 24.3873 8.59155 25.0201 8.31574L25.2351 8.22208C26.6643 7.60033 28.3238 8.257 28.9435 9.6836L28.9518 9.70314L32.8074 19.0079ZM14.1671 32.0833C14.1671 31.393 14.7267 30.8333 15.4171 30.8333C16.1074 30.8333 16.6671 31.393 16.6671 32.0833C16.6671 32.7737 16.1074 33.3333 15.4171 33.3333C14.7267 33.3333 14.1671 32.7737 14.1671 32.0833ZM31.6667 23.3333C27.065 23.3333 23.3333 27.065 23.3333 31.6666C23.3333 36.2683 27.065 40 31.6667 40C36.2683 40 40 36.2683 40 31.6666C40 27.065 36.2683 23.3333 31.6667 23.3333ZM36.2386 33.6561L35.6908 34.6295C35.5075 34.9557 35.0789 35.0457 34.7796 34.8211L32.4872 33.1017L32.827 35.9271C32.8711 36.2961 32.5834 36.6206 32.2123 36.6206H31.122C30.7508 36.6206 30.4627 36.2961 30.5073 35.9275L30.847 33.1021L28.5542 34.8211C28.2549 35.0457 27.8264 34.9553 27.6431 34.6295L27.0952 33.6561C26.9107 33.3283 27.0585 32.913 27.409 32.7759L30.1196 31.7129L27.3871 30.5772C27.0457 30.4352 26.9037 30.0277 27.0837 29.7045L27.6336 28.7162C27.8193 28.381 28.2623 28.2943 28.5616 28.5341L30.8598 30.377L30.5056 27.4054C30.4623 27.0368 30.75 26.7127 31.1207 26.7127H32.2127C32.5838 26.7127 32.8716 27.0368 32.8274 27.405L32.4732 30.3766L34.7714 28.5337C35.0707 28.2938 35.5137 28.3805 35.6998 28.7158L36.2497 29.7041C36.4293 30.0273 36.2877 30.4348 35.9463 30.5768L33.2138 31.7125L35.9244 32.7755C36.2753 32.913 36.4231 33.3283 36.2386 33.6561Z" fill="#1D2540"/>
</g>
<defs>
<clipPath id="clip0_15598_103288">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>
    )}
    const MultiDayDeliveryIcon = ({
      width = 24,
      height = 24,
      color1 = "#FFBA07",
      color2 = "#1D2540",
    }) => {
      return (
<svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_15598_103196)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.8335 18.8099V28.9173C5.8335 30.9173 7.41683 32.5007 9.41683 32.5007H28.3335L27.5002 32.584H29.6212C29.8643 34.1824 31.2533 35.4173 32.9168 35.4173C34.5803 35.4173 35.9694 34.1824 36.2125 32.584H37.4168C38.8335 32.584 40.0002 31.4173 40.0002 30.0007V24.7507C40.0002 24.334 39.9168 24.0007 39.7502 23.6673L37.3335 18.1673C36.9168 17.2507 36.0002 16.6673 35.0002 16.6673H29.2502V13.4173C29.2502 12.0007 28.0835 10.834 26.6668 10.834H18.9865C17.8439 15.5923 13.5611 19.1286 8.45231 19.1286C7.54931 19.1286 6.67211 19.0181 5.8335 18.8099Z" fill="#13B57B"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.53499 0.0449219C3.93499 0.0449219 0.20166 3.77825 0.20166 8.37825C0.20166 12.9783 3.93499 16.7116 8.53499 16.7116C13.135 16.7116 16.8683 12.9783 16.8683 8.37825C16.8683 3.77825 13.135 0.0449219 8.53499 0.0449219ZM13.024 10.2848L12.4762 11.2582C12.2929 11.5843 11.8644 11.6743 11.5651 11.4498L9.27263 9.73033L9.61239 12.5557C9.65656 12.9248 9.36882 13.2493 8.99768 13.2493H7.9074C7.53627 13.2493 7.24811 12.9248 7.2927 12.5561L7.63246 9.73074L5.3396 11.4498C5.0403 11.6743 4.61179 11.5839 4.42849 11.2582L3.88067 10.2848C3.69613 9.95697 3.84392 9.54166 4.19442 9.4046L6.90505 8.34157L4.17254 7.20587C3.83113 7.06386 3.68911 6.6564 3.86911 6.33315L4.41899 5.34484C4.60477 5.00962 5.04773 4.92293 5.34703 5.16278L7.64526 7.00565L7.29105 4.03411C7.2477 3.66545 7.53544 3.34138 7.90616 3.34138H8.9981C9.36923 3.34138 9.65697 3.66545 9.6128 4.03369L9.25859 7.00524L11.5568 5.16237C11.8561 4.92252 12.2991 5.00921 12.4853 5.34443L13.0352 6.33274C13.2147 6.65599 13.0731 7.06345 12.7317 7.20546L9.99921 8.34116L12.7098 9.40419C13.0607 9.54166 13.2085 9.95697 13.024 10.2848ZM19.2853 8.29535C19.2853 8.5889 19.2736 8.87973 19.2507 9.16739H22.9165C23.6428 9.16739 24.1665 9.69108 24.1665 10.4174V27.3341C24.1665 27.3906 24.1703 27.4462 24.1775 27.5007H16.0993V20.0054C16.0993 19.315 15.5396 18.7554 14.8493 18.7554C14.1589 18.7554 13.5993 19.315 13.5993 20.0054L13.5993 31.987L13.5589 31.9466C13.0708 31.4584 12.2793 31.4584 11.7911 31.9466C11.303 32.4347 11.303 33.2262 11.7911 33.7144L13.9653 35.8885C14.1997 36.1229 14.5177 36.2546 14.8492 36.2546C15.1807 36.2546 15.4987 36.1229 15.7331 35.8885L17.9072 33.7144C18.3954 33.2262 18.3954 32.4347 17.9072 31.9466C17.4191 31.4584 16.6276 31.4584 16.1395 31.9466L16.0993 31.9868V30.0007H25.1737C25.7203 31.9206 27.4925 33.3341 29.5832 33.3341C31.6738 33.3341 33.4461 31.9206 33.9927 30.0007H34.5832C36.6902 30.0007 38.3332 28.3577 38.3332 26.2507V20.9174C38.3332 20.3766 38.1986 19.8608 37.9624 19.381L35.489 13.9395C34.9421 12.5053 33.5314 11.6674 32.0832 11.6674H26.6665V10.4174C26.6665 8.31037 25.0235 6.66739 22.9165 6.66739H19.1638C19.2438 7.19839 19.2853 7.74203 19.2853 8.29535ZM29.5832 24.1674C28.477 24.1674 27.46 24.5631 26.6665 25.2201V14.1674H32.0832C32.618 14.1674 33.0245 14.4764 33.1584 14.8446C33.1695 14.8751 33.1818 14.9051 33.1952 14.9346L34.7404 18.3341H29.3333C28.643 18.3341 28.0833 18.8937 28.0833 19.5841C28.0833 20.2744 28.643 20.8341 29.3333 20.8341H35.8285C35.8318 20.8632 35.8332 20.891 35.8332 20.9174V26.2507C35.8332 26.977 35.3095 27.5007 34.5832 27.5007H33.9927C33.4461 25.5809 31.6738 24.1674 29.5832 24.1674ZM29.5832 26.6674C28.4402 26.6674 27.4998 27.6077 27.4998 28.7507C27.4998 29.8937 28.4402 30.8341 29.5832 30.8341C30.7261 30.8341 31.6665 29.8937 31.6665 28.7507C31.6665 27.6077 30.7261 26.6674 29.5832 26.6674ZM2.9165 19.5841C3.60686 19.5841 4.1665 20.1437 4.1665 20.8341V26.2507C4.1665 26.977 4.69019 27.5007 5.4165 27.5007H7.08317C7.77353 27.5007 8.33317 28.0604 8.33317 28.7507C8.33317 29.4411 7.77353 30.0007 7.08317 30.0007H5.4165C3.30948 30.0007 1.6665 28.3577 1.6665 26.2507V20.8341C1.6665 20.1437 2.22615 19.5841 2.9165 19.5841Z" fill="#1D2540"/>
</g>
<defs>
<clipPath id="clip0_15598_103196">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>
      )}

const CrossDockPickup = ({
  width = 24,
  height = 24,
  color1 = "#AABDCD",
  color2 = "#1D2540",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 16.06V20.44C21.5 21.58 20.575 22.5 19.44 22.5H8.56C7.425 22.5 6.5 21.575 6.5 20.44V7.56C6.5 6.42 7.425 5.5 8.56 5.5H19.44C20.58 5.5 21.5 6.425 21.5 7.56V11.94V16.06Z"
        fill={color1}
        fill-opacity="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.25 5.75C5.25 5.05921 5.80921 4.5 6.5 4.5H17.5C18.1908 4.5 18.75 5.05921 18.75 5.75V9.63C18.75 10.0442 19.0858 10.38 19.5 10.38C19.9142 10.38 20.25 10.0442 20.25 9.63V5.75C20.25 4.23079 19.0192 3 17.5 3H6.5C4.98079 3 3.75 4.23079 3.75 5.75V14C3.75 14.4142 4.08579 14.75 4.5 14.75C4.91421 14.75 5.25 14.4142 5.25 14V5.75ZM20.25 14C20.25 13.5858 19.9142 13.25 19.5 13.25C19.0858 13.25 18.75 13.5858 18.75 14V18.25C18.75 18.9408 18.1908 19.5 17.5 19.5H6.5C5.80921 19.5 5.25 18.9408 5.25 18.25V17.065C5.25 16.6508 4.91421 16.315 4.5 16.315C4.08579 16.315 3.75 16.6508 3.75 17.065V18.25C3.75 19.7692 4.98079 21 6.5 21H17.5C19.0192 21 20.25 19.7692 20.25 18.25V14Z"
        fill={color2}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.25 15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15L12.75 9.56066L13.4697 10.2803C13.7626 10.5732 14.2374 10.5732 14.5303 10.2803C14.8232 9.98744 14.8232 9.51256 14.5303 9.21967L12.5303 7.21967C12.2374 6.92678 11.7626 6.92678 11.4697 7.21967L9.46967 9.21967C9.17678 9.51256 9.17678 9.98744 9.46967 10.2803C9.76256 10.5732 10.2374 10.5732 10.5303 10.2803L11.25 9.56066L11.25 15Z"
        fill={color2}
      />
    </svg>
  );
};

const LineHaulOriginIcon = ({
  width = 24,
  height = 24,
  color1 = "#FFBA07",
  color2 = "#33393D",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 12.5508C21.5 8.40078 18.15 5.05078 14 5.05078C9.85 5.05078 6.5 8.40078 6.5 12.5508C6.5 14.4008 7.2 16.1008 8.3 17.4008C8.3 17.4008 11.85 21.4508 13 22.5508C13.55 23.1008 14.45 23.1008 15 22.5508C16.35 21.3008 19.7 17.4008 19.7 17.4008C20.8 16.1008 21.5 14.4008 21.5 12.5508Z"
        fill={color1}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 1.94922C9.9216 1.94922 8.04923 2.66284 6.56371 3.92829C6.2484 4.19689 6.21053 4.67025 6.47913 4.98557C6.74773 5.30089 7.2211 5.33875 7.53641 5.07015C8.75089 4.03559 10.2785 3.44922 12.0001 3.44922C15.8859 3.44922 19.0001 6.56343 19.0001 10.4492C19.0001 12.2128 18.369 13.7904 17.3324 15.009L17.3205 15.0226L17.3099 15.0347L17.2749 15.0744C17.2349 15.1198 17.1762 15.1862 17.102 15.2697C16.9535 15.4368 16.7429 15.6722 16.4951 15.9447C16.2165 16.2512 16.2391 16.7255 16.5456 17.0042C16.8521 17.2828 17.3264 17.2602 17.605 16.9537C17.8572 16.6763 18.0716 16.4367 18.2231 16.2662C18.2989 16.181 18.359 16.113 18.4002 16.0662L18.4476 16.0123L18.4645 15.9931L18.471 15.9856C19.7324 14.5048 20.5001 12.5838 20.5001 10.4492C20.5001 5.735 16.7143 1.94922 12.0001 1.94922ZM5 10.2492C5 9.83499 4.66421 9.49921 4.25 9.49921C3.83579 9.49921 3.5 9.83499 3.5 10.2492V10.4992C3.5 12.5884 4.27052 14.5036 5.52046 16.0253C5.52593 16.0319 5.53153 16.0385 5.53723 16.045L6.1 15.5492C5.53723 16.045 5.53739 16.0452 5.53742 16.0452L5.57946 16.0929L5.6993 16.2286C5.80303 16.3459 5.95242 16.5147 6.13524 16.7206C6.50083 17.1324 7.00044 17.6931 7.53628 18.2884C8.59796 19.4681 9.83169 20.8174 10.4316 21.3912L10.4432 21.4021C11.3066 22.1936 12.6439 22.2337 13.5003 21.409C13.7979 21.1628 14.122 20.7846 14.3873 20.4748L14.4194 20.4373C14.689 20.1228 14.6526 19.6493 14.3381 19.3798C14.0236 19.1102 13.5501 19.1466 13.2806 19.4611C12.9609 19.8341 12.7133 20.1181 12.5315 20.2636C12.5099 20.2808 12.4892 20.2993 12.4697 20.3189C12.2259 20.5626 11.7878 20.5952 11.4619 20.301C10.909 19.7709 9.72284 18.4757 8.65122 17.285C8.11831 16.6929 7.62105 16.1348 7.25694 15.7247C7.07493 15.5197 6.92626 15.3517 6.82316 15.2351L6.70421 15.1004L6.67147 15.0633C5.62625 13.7867 5 12.2057 5 10.4992V10.2492ZM12 14.2492C11.5858 14.2492 11.25 13.9134 11.25 13.4992L11.25 8.80987L10.0303 10.0295C9.73744 10.3224 9.26256 10.3224 8.96967 10.0295C8.67678 9.73664 8.67678 9.26177 8.96967 8.96888L11.4697 6.46888C11.7626 6.17598 12.2374 6.17598 12.5303 6.46888L15.0303 8.96888C15.3232 9.26177 15.3232 9.73664 15.0303 10.0295C14.7374 10.3224 14.2626 10.3224 13.9697 10.0295L12.75 8.80987V13.4992C12.75 13.9134 12.4142 14.2492 12 14.2492Z"
        fill={color2}
      />
    </svg>
  );
};

const LineHaulDestinationIcon = ({
  width = 24,
  height = 24,
  color1 = "#FFBA07",
  color2 = "#1D2540",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 12.5508C21.5 8.40078 18.15 5.05078 14 5.05078C9.85 5.05078 6.5 8.40078 6.5 12.5508C6.5 14.4008 7.2 16.1008 8.3 17.4008C8.3 17.4008 11.85 21.4508 13 22.5508C13.55 23.1008 14.45 23.1008 15 22.5508C16.35 21.3008 19.7 17.4008 19.7 17.4008C20.8 16.1008 21.5 14.4008 21.5 12.5508Z"
        fill={color1}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 1.94922C9.9216 1.94922 8.04923 2.66284 6.56371 3.92829C6.2484 4.19689 6.21053 4.67025 6.47913 4.98557C6.74773 5.30089 7.2211 5.33875 7.53641 5.07015C8.75089 4.03559 10.2785 3.44922 12.0001 3.44922C15.8859 3.44922 19.0001 6.56343 19.0001 10.4492C19.0001 12.2128 18.369 13.7904 17.3324 15.009L17.3205 15.0226L17.3099 15.0347L17.2749 15.0744C17.2349 15.1198 17.1762 15.1862 17.102 15.2697C16.9535 15.4368 16.7429 15.6722 16.4951 15.9447C16.2165 16.2512 16.2391 16.7255 16.5456 17.0042C16.8521 17.2828 17.3264 17.2602 17.605 16.9537C17.8572 16.6763 18.0716 16.4367 18.2231 16.2662C18.2989 16.181 18.359 16.113 18.4002 16.0662L18.4476 16.0123L18.4645 15.9931L18.471 15.9856C19.7324 14.5048 20.5001 12.5838 20.5001 10.4492C20.5001 5.735 16.7143 1.94922 12.0001 1.94922ZM5 10.2492C5 9.83499 4.66421 9.49921 4.25 9.49921C3.83579 9.49921 3.5 9.83499 3.5 10.2492V10.4992C3.5 12.5884 4.27052 14.5036 5.52046 16.0253C5.52593 16.0319 5.53153 16.0385 5.53723 16.045L6.1 15.5492C5.53723 16.045 5.53739 16.0452 5.53742 16.0452L5.57946 16.0929L5.6993 16.2286C5.80303 16.3459 5.95242 16.5147 6.13524 16.7206C6.50083 17.1324 7.00044 17.6931 7.53628 18.2884C8.59796 19.4681 9.83169 20.8174 10.4316 21.3912L10.4432 21.4021C11.3066 22.1936 12.6439 22.2337 13.5003 21.409C13.7979 21.1628 14.122 20.7846 14.3873 20.4748L14.4194 20.4373C14.689 20.1228 14.6526 19.6493 14.3381 19.3798C14.0236 19.1102 13.5501 19.1466 13.2806 19.4611C12.9609 19.8341 12.7133 20.1181 12.5315 20.2636C12.5099 20.2808 12.4892 20.2993 12.4697 20.3189C12.2259 20.5626 11.7878 20.5952 11.4619 20.301C10.909 19.7709 9.72284 18.4757 8.65122 17.285C8.11831 16.6929 7.62105 16.1348 7.25694 15.7247C7.07493 15.5197 6.92626 15.3517 6.82316 15.2351L6.70421 15.1004L6.67147 15.0633C5.62625 13.7867 5 12.2057 5 10.4992V10.2492ZM12 6.24921C12.4142 6.24921 12.75 6.58499 12.75 6.99921V11.6885L13.9697 10.4689C14.2626 10.176 14.7374 10.176 15.0303 10.4689C15.3232 10.7618 15.3232 11.2366 15.0303 11.5295L12.5303 14.0295C12.2374 14.3224 11.7626 14.3224 11.4697 14.0295L8.96967 11.5295C8.67678 11.2366 8.67678 10.7618 8.96967 10.4689C9.26256 10.176 9.73744 10.176 10.0303 10.4689L11.25 11.6885L11.25 6.99921C11.25 6.58499 11.5858 6.24921 12 6.24921Z"
        fill={color2}
      />
    </svg>
  );
};

const FormTemplateIcon = ({
  width = "56",
  height = "56",
  color = "#1D2540",
  style = {},
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 56 56`}
    focusable="false"
    data-icon="assign"
    fill="none"
    aria-hidden="true"
    style = {style}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83325 12.25C5.83325 11.2835 6.61675 10.5 7.58325 10.5H48.4166C49.3831 10.5 50.1666 11.2835 50.1666 12.25C50.1666 13.2165 49.3831 14 48.4166 14H7.58325C6.61675 14 5.83325 13.2165 5.83325 12.25Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39.9657 28.8771C39.7123 28.3703 39.0061 28.3703 38.7527 28.8771L38.7479 28.8867L36.2977 33.7129C35.7996 34.8137 34.8173 35.4383 33.7792 35.5906L27.5741 36.5621L27.5699 36.5628C27.0116 36.6488 26.8041 37.3248 27.1934 37.7141L31.3321 41.8528C32.2491 42.6469 32.4609 43.8244 32.3306 44.7389L32.3275 44.7595L31.3549 51.048C31.3548 51.0482 31.3549 51.0478 31.3549 51.048C31.3179 51.2903 31.4117 51.4996 31.6242 51.647C31.8453 51.8002 32.1063 51.8217 32.3355 51.7021C33.1924 51.2551 34.2495 51.5873 34.6965 52.4442C35.1435 53.3012 34.8112 54.3582 33.9543 54.8052C31.0299 56.3309 27.3676 53.9576 27.8953 50.5173L28.8533 44.3238L24.7185 40.1889C22.2617 37.7321 23.7026 33.6192 27.0345 33.1039C27.0353 33.1038 27.0361 33.1037 27.0369 33.1036L33.1693 32.1435L35.6249 27.3065C37.1696 24.2272 41.5487 24.2272 43.0934 27.3064L43.4704 28.0488C43.908 28.9106 43.5642 29.9639 42.7024 30.4015C41.8407 30.8391 40.7874 30.4953 40.3497 29.6335L39.9706 28.8869L39.9657 28.8771ZM28.8667 44.2293C28.8667 44.2282 28.8667 44.2293 28.8667 44.2293V44.2293Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.4723 33.5883C43.6218 32.6334 44.5171 31.9806 45.4719 32.1301L51.6824 33.1024C51.6833 33.1025 51.6841 33.1026 51.6849 33.1028C55.1159 33.633 56.2898 37.7751 54.0334 40.1545C54.0192 40.1695 54.0047 40.1843 53.9899 40.1988L49.7905 44.3236L50.7482 50.5152C51.2613 53.8473 47.7788 56.4694 44.6743 54.7962L39.3567 51.9895C38.4999 52.3945 37.4721 52.0429 37.0452 51.1912C36.612 50.3272 36.9613 49.2757 37.8253 48.8426C38.7681 48.37 39.9491 48.37 40.8918 48.8426C40.9028 48.848 40.9136 48.8536 40.9244 48.8593L46.3156 51.7048L46.3325 51.7139C46.8212 51.9787 47.3748 51.6069 47.289 51.0482C47.289 51.0481 47.289 51.0483 47.289 51.0482L46.3174 44.7661C46.1549 43.7649 46.4849 42.6783 47.2573 41.9059L47.2685 41.8949L51.509 37.7297C51.695 37.5224 51.7402 37.2559 51.6599 37.0064C51.5803 36.7591 51.405 36.6009 51.1498 36.5616L51.1454 36.5609L44.9306 35.5879C43.9757 35.4384 43.3228 34.5432 43.4723 33.5883Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83325 28C5.83325 27.0335 6.61675 26.25 7.58325 26.25H30.9166C31.8831 26.25 32.6666 27.0335 32.6666 28C32.6666 28.9665 31.8831 29.75 30.9166 29.75H7.58325C6.61675 29.75 5.83325 28.9665 5.83325 28Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83325 43.75C5.83325 42.7835 6.61675 42 7.58325 42H20.4166C21.3831 42 22.1666 42.7835 22.1666 43.75C22.1666 44.7165 21.3831 45.5 20.4166 45.5H7.58325C6.61675 45.5 5.83325 44.7165 5.83325 43.75Z"
      fill={color}
    />
  </svg>
);

const getOrderTypeCode = (type) => {
  return typeof type === "object" && type !== null ? (type.extraCode || type.code) : type;
};

const getOrderTypeLabel = (type) => {
  return typeof type === "object" && type !== null ? (type.label || type.toolTipLabel || type.code || "") : type;
};

const getOrderTypeIcon = (type, props,) => {
  const code = getOrderTypeCode(type);
  switch (code) {
    case "R":
    case "OR":
    case "SDR":
      return <Icon component={() => <PickupIcon {...props} />} {...props} />;
    case "PLH":
      return (
        <Icon component={() => <img src={PickupLinehaul} {...props} alt="" />} {...props} />
      );
    case "MDR":
      return <Icon component={() => <PickupMultiIcon {...props} />} {...props} />;
    case "D":
    case "SDD":
    case "OD":
      return <Icon component={() => <DeliveryIcon {...props} />} {...props} />;
    case "LHD":
      return (
        <Icon component={() => <img src={LinehaulDelivery} {...props} alt="" />} {...props} />
      );
    case "MDD":
      return <Icon component={() => <DeliveryMultiIcon {...props} />} {...props} />;
    case "T":
      return (
        <Icon component={() => <PickupDeliveryIcon {...props} />} {...props} />
      );
    case "B":
      return (
        <Icon component={() => <BeyondIcon {...props} />} {...props} />
      );
    case "E":
      return (
        <Icon component={() => <ExclusiveIcon {...props} />} {...props} />
      );
    case "H":
      return (
        <Icon component={() => <HotshotIcon {...props} />} {...props} />
      );
    case "PLHD":
      return (
        <Icon component={() => <img src={LinehaulTransfer} {...props} alt="" />} {...props} />
      );
    case "M":
      return (
        <Icon component={() => <MoveOrderIcon {...props} />} {...props} />
      )
    case "NLH":
      return (
        <Icon component={() => <img src={Linehaul} {...props} alt="" />} {...props} />
      );
    case "LH":
      return <Icon component={() => <LineHaulIcon {...props} />} {...props} />;
    // case "RD": return <Icon component={() => <RecoveryAndDeliveryIcon {...props} />}{...props} />;

    case "RD":
      return (
        <Icon
          component={() => <RecoveryAndDeliveryIcon {...props} />}
          {...props}
          rotate={180}
        />
      );
    case "RT":
    case "AFW":
      return (
        <Icon
          component={() => <RecoveryAndTransferIcon {...props} />}
          {...props}
        />
      );
    case "OBT":
      return (
        <Icon
          component={() => <OutboundTransferIcon {...props} />}
          {...props}
        />
      );
    case "CDK":
      return <Icon component={() => <CrossDockIcon {...props} />} {...props} />;
    case "WO":
      return <Icon component={() => <WarehouseStorageIcon {...props} />} {...props} />;
    case "PCDK":
      return (
        <Icon
          component={() => <CrossDockIconPickupIcon {...props} />}
          {...props}
        />
      );
    case "CDKD":
      return (
        <Icon
          component={() => <CrossDockDeliveryIcon {...props} />}
          {...props}
        />
      );
    case "MS":
      return <Icon component={() => <MultiStopIcon {...props} />} {...props} />;
    case "RO":
      return <Icon component={() => <CrossDockIcon {...props} />} {...props} />;
    case "OS":
      return <Icon component={() => <OnSiteServiceIcon {...props} />} {...props} />;
    case "APAD":
      return (
        <Icon component={() => <PickupDeliveryIcon {...props} />} {...props} />
      );
    default:
      return <Icon component={() => <PickupIcon {...props} />} {...props} />;
  }
};

const showOrderLabelIcon = (type, props) => {
  const code = getOrderTypeCode(type);
  switch (code) {
    case "R":
      return <Icon component={() => <PickupIcon {...props} />} {...props} />;
    case "D":
      return <Icon component={() => <DeliveryIcon {...props} />} {...props} />;
    case "T":
      return (
        <Icon component={() => <PickupDeliveryIcon {...props} />} {...props} />
      );
    case "B":
      return (
        <Icon component={() => <BeyondIcon {...props} />} {...props} />
      );
    case "E":
      return (
        <Icon component={() => <ExclusiveIcon {...props} />} {...props} />
      );
    case "H":
      return (
        <Icon component={() => <HotshotIcon {...props} />} {...props} />
      );
    case "LH":
      return <Icon component={() => <LineHaulIcon {...props} />} {...props} />;
    case "RD":
      return (
        <Icon
          component={() => <RecoveryAndDeliveryIcon {...props} />}
          {...props}
        />
      );
    case "RT":
    case "AFW":  
      return (
        <Icon
          component={() => <RecoveryAndTransferIcon {...props} />}
          {...props}
        />
      );
    case "OBT":
      return (
        <Icon
          component={() => <OutboundTransferIcon {...props} />}
          {...props}
        />
      );
    case "CDK":
      return <Icon component={() => <CrossDockIcon {...props} />} {...props} />;
    case "PCDK":
      return (
        <Icon
          component={() => <CrossDockIconPickupIcon {...props} />}
          {...props}
        />
      );
    case "CDKD":
      return (
        <Icon
          component={() => <CrossDockDeliveryIcon {...props} />}
          {...props}
        />
      );
    case "MS":
      return <Icon component={() => <MultiStopIcon {...props} />} {...props} />;
    case "RO":
      return <Icon component={() => <CrossDockIcon {...props} />} {...props} />;
    case "OS":
      return <Icon component={() => <OnSiteServiceIcon {...props} />} {...props} />;
    default:
      return <Icon component={() => <PickupIcon {...props} />} {...props} />;
  }
};
const getOrderTypeIconForLocation = (keyCode, props) => {
  switch (keyCode) {
    case "R-R":
    case "T-R":
    case "OBT-R":
    case "PCDK-R":
    case "M-R":
    case "OD-R":
    case "OR-R":
    case "TR-R":
    case "PLH-R":
    case "PLHD-R":
    case "APAD-R":
    case "B-R":
    case "E-R":
    case "H-R":
      return <Icon component={() => <PickupIcon {...props} />} {...props} />;
    case "D-D":
    case "T-D":
    case "RD-D":
    case "CDKD-D":
    case "M-D":
    case "OR-D":
    case "OD-D":
    case "TD-D":
    case "LHD-D":
    case "PLHD-D":
    case "OS-D":
    case "APAD-D":
    case "B-D":
    case "E-D":
    case "H-D":
      return <Icon component={() => <DeliveryIcon {...props} />} {...props} />;
    case "RD-REC":
    case "RT-REC":
    case "AFW-R":
      return (
        <Icon component={() => <RecoveryIcon_v2 {...props} />} {...props} />
      );
    case "RT-TRANS":
    case "OBT-TRANS":
    case "AFW-D":
      return (
        <Icon
          component={() => <RecoveryTransferTransIcon {...props} />}
          {...props}
        />
      );
    case "CDK-DRPF":
    case "WO-DRPF":
      return (
        <Icon component={() => <CrossDockDropoff {...props} />} {...props} />
      );
    case "CDK-R":
    case "WO-R":
      return (
        <Icon component={() => <CrossDockPickup {...props} />} {...props} />
      );
    case "CDKD-CDK":
    case "PCDK-CDK":
      return <Icon component={() => <CrossDockIcon {...props} />} {...props} />;
    case "LH-ORN":
    case "NLH-ORN":
    case "LHD-ORN":
      return (
        <Icon component={() => <LineHaulOriginIcon {...props} />} {...props} />
      );
    case "LH-DST":
    case "NLH-DST":
    case "PLH-DST":
      return (
        <Icon
          component={() => <LineHaulDestinationIcon {...props} />}
          {...props}
        />
      );

    default:
      return <Icon component={() => <PickupIcon {...props} />} {...props} />;
  }
};
const getOrderTypeIconForLocationMap = (keyCode, props) => {
  switch (keyCode) {
    case "R-R":
    case "T-R":
    case "OBT-R":
    case "PCDK-R":
    case "OD-R":
    case "OR-R":
    case "MDD-R":
    case "SDD-R":
    case "PLH-R":
    case "PLHD-R":
    case "B-R":
    case "E-R":
    case "H-R":
      return <img src={MapPickupIcon} {...props} alt="" />
    case "D-D":
    case "T-D":
    case "RD-D":
    case "CDKD-D":
    case "OD-D":
    case "OR-D":
    case "MDD-D":
    case "SDD-D":
    case "MS-D":
    case "LHD-D":
    case "PLHD-D":
    case "OS-D":
    case "B-D":
    case "E-D":
    case "H-D":
      return <img src={MapDeliveryIcon} {...props} alt="" />
    case "RD-REC":
    case "AFW-R":  
    case "RT-REC":
      return <img src={MapRecoveryIcon} {...props} alt="" />
    case "RT-TRANS":
    case "AFW-D":
    case "OBT-TRANS":
      return <img src={MapOutboundTransfer} {...props} alt="" />
    case "CDK-DRPF":
    case "WO-DRPF":
      return <img src={MapInboundIcon} {...props} alt="" />
    case "CDK-R":
    case "WO-R":
      return (
        <img src={MapPickupCrossdockIcon} {...props} alt="" />
      )
    case "CDKD-CDK":
    case "PCDK-CDK":
      return <img src={MapCrossdockIcon} {...props} alt="" />
    case "LH-ORN":
    case "NLH-ORN":
    case "LHD-ORN":
      return <img src={MapCrossdockDeliveryIcon} {...props} alt="" />
    case "LH-DST":
    case "NLH-DST":
    case "PLH-DST":
      return <img src={MapPickupCrossdockIcon} {...props}alt="" />
    default:
      return <img src={MapPickupIcon} {...props} alt="" />
  }
};

const getColorForTitleCreateOrderScreen = (typeOfOrder, fontSize, lineHeight, orgCode = "", isCLIEnabled = false) => {
  const code = getOrderTypeCode(typeOfOrder);
  const label = getOrderTypeLabel(typeOfOrder);
  const baseStyle = {
    ...(fontSize && { fontSize }), 
    ...(lineHeight && { lineHeight }),
  }
  switch (code) {
    case "R":
      return (
        <span className="create-order-heading" style={{...baseStyle, color: "#FF2D78" }}>
          {orgCode !== "TA" ? "Pickup" : "Pickup Only" }
        </span>
      );
    case "D":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#11A16E" }}>
          {orgCode !== "TA" ? "Delivery" : "Delivery Only" }
        </span>
      );
    case "M":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#586fcc" }}>
          Move
        </span>
      )
    case "T":
      return (
        <span className="create-order-heading">
          {orgCode == "MWE" ? (
            <span style={{ ...baseStyle, color: "#586FCC" }}>Local To Local</span>
          ) : (
            <>
              <span style={{ ...baseStyle, color: "#586FCC" }}>Pickup</span>{" "}
              <span style={{ ...baseStyle, color: "#586FCC"}}>&</span>{" "}
              <span style={{ ...baseStyle, color: "#586FCC" }}>Delivery</span>
            </>
          )}
        </span>
      );
    case "B":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#5B6EF5" }}>
          Beyond
        </span>
      );
    case "E":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#F59E0B" }}>
          Exclusive
        </span>
      );
    case "H":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#EF4444" }}>
          Hotshot
        </span>
      );
    case "AFW":
      return (
        <span className="create-order-heading">
          <span style={{ ...baseStyle, color: "#586FCC" }}>Recovery</span>{" "}
          <span style={{ ...baseStyle, color: "#586FCC"}}>&</span>{" "}
          <span style={{ ...baseStyle, color: "#586FCC" }}>Transfer (AFW)</span>
        </span>
      );
    case "OR":
        return (
          <span className="create-order-heading" style={{...baseStyle, color: "#FF2D78" }}>
          Pickup
        </span>
        );
    case "OD":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#11A16E" }}>
          Delivery
        </span>
      );
    case "RD":
      return (
        <span className="create-order-heading">
          {isCLIEnabled ? (
            <span style={{ ...baseStyle, color: "#2BACFB" }}>Delivery Airline</span>
          ) : (
            <>
              <span style={{ ...baseStyle, color: "#2BACFB" }}>Recovery</span> {" "}
              <span style={{ ...baseStyle, color: "#2BACFB" }}>&</span>{" "}
              <span style={{ ...baseStyle, color: "#2BACFB" }}>Delivery</span>
            </>
          )}
        </span>
      );
    case "RT":
      return (
        <span className="create-order-heading">
          <span style={{ ...baseStyle, color: "#D62BF9" }}>Recovery</span> {" "}
          <span style={{ ...baseStyle, color: "#D62BF9" }}>&</span>{" "}
          <span style={{ ...baseStyle, color: "#D62BF9" }}>Transfer</span>
        </span>
      );
    case "OBT":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#FE8C36" }}>
          {isCLIEnabled ? "P/U" : "Outbound Transfer"}
        </span>
      );
    case "CDK":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#99AAB9" }}>
          Cross Dock
        </span>
      );
    case "WO":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#99AAB9" }}>
          {I18n.t('general.warehouse')} Storage
        </span>
      );
    case "PCDK":
      return (
        <span className="create-order-heading">
          <span style={{ ...baseStyle, color: "#EB548A" }}>Pickup </span> {" "}
          <span style={{ ...baseStyle, color: "#EB548A" }}>&</span>{" "}
          <span style={{ ...baseStyle, color: "#EB548A" }}>Cross Dock</span>
        </span>
      );
    case "CDKD":
      return (
        <span className="create-order-heading">
          <span style={{ ...baseStyle, color: "#15C989" }}>Cross Dock</span> {" "}
          <span style={{ ...baseStyle, color: "#15C989" }}>&</span>{" "}
          <span style={{ ...baseStyle, color: "#15C989" }}>Delivery</span>
        </span>
      );
    case "LH":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#CC9506" }}>
          Linehaul (legacy)
        </span>
      );
    case "MS":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#B38205" }}>
          Multi-Stop
        </span>
      );
    case "PLH":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#FF2D78" }}>
          {orgCode == "MWE" ? "Door To Terminal" : "Pickup & Linehaul"}
        </span>
      );
      case "LHD":
        return (
          <span className="create-order-heading" style={{ ...baseStyle, color: "#11A16E" }}>
            {orgCode == "MWE" ? "Terminal To Door" : "Linehaul & Delivery"}
          </span>
        );
      case "PLHD":
        return (
          <span className="create-order-heading" style={{ ...baseStyle, color: "#586FCC" }}>
            {orgCode == "SSF" ? "Line Haul" : orgCode == "MWE" ? "Door To Door" : "Pickup,Linehaul & Delivery"}
          </span>
        );
      case "NLH":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#CC9506" }}>
          {orgCode == "MWE" ? "Terminal To Terminal" : "Linehaul"}
        </span>
      );
      case "OS":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#AABDCD" }}>
          On-Site Service
        </span>
      );
    case "APAD":
      return (
        <span className="create-order-heading" style={{ ...baseStyle, color: "#586FCC" }}>
          Airport to Airport
        </span>
      );
    default:
      return <span className="create-order-heading">{label}</span>;
  }
};

export const getColorForTitleCreateOrderScreen_v2 = (typeOfOrder , color = null, orgCode = "", isCLIEnabled = false) => {
  const code = getOrderTypeCode(typeOfOrder);
  const label = getOrderTypeLabel(typeOfOrder);
  switch (code) {
    case "OR":
      return (
        <span  style={{ color: color || "#FF2D78" }}>
          Pickup
        </span>
      );
    case "OD":
      return (
        <span  style={{ color: color || "#11A16E" }}>
          Delivery
        </span>
      );
    case "R":
      return (
        <span  style={{ color: color || "#FF2D78" }}>
          {orgCode !== "TA" ? "Pickup" : "Pickup Only"}
        </span>
      );
    case "D":
      return (
        <span  style={{ color: color || "#11A16E" }}>
          {orgCode !== "TA" ? "Delivery" : "Delivery Only"}
        </span>
      );
    case "M":
      return (
        <span  style={{ color: color || "#8195DE" }}>
          Move
        </span>
      )
    case "SDR":
      return (
        <span  style={{ color: color || "#FF2D78" }}>
          Single Day Pickup
        </span>
      )
    case "SDD":
      return (
        <span  style={{ color: color || "#11A16E" }}>
          Single Day Delivery
        </span>
      )
    case "MDR":
      return (
        <span  style={{ color: color || "#FF2D78" }}>
          Multi Day Pickup
        </span>
      )
    case "MDD":
      return (
        <span  style={{ color: color || "#11A16E" }}>
          Multi Day Delivery
        </span>
      )
    case "T":
      return (
        <span >
          {orgCode == "MWE" ? (
            <span style={{ color: color || "#FF2D78" }}>Local To Local</span>
          ) : (
            <>
              <span style={{ color: color || "#FF2D78" }}>Pickup</span> &{" "}
              <span style={{ color: color || "#11A16E" }}>Delivery</span>
            </>
          )}
        </span>
      );
    case "B":
      return (
        <span style={{ color: color || "#5B6EF5" }}>
          Beyond
        </span>
      );
    case "E":
      return (
        <span style={{ color: color || "#F59E0B" }}>
          Exclusive
        </span>
      );
    case "H":
      return (
        <span style={{ color: color || "#EF4444" }}>
          Hotshot
        </span>
      );
    case "AFW":
      return (
        <span >
          <span style={{ color: color || "#FF2D78" }}>Recovery</span> &{" "}
          <span style={{ color: color || "#11A16E" }}>Transfer</span> {"(AFW)"}
        </span>
      );
    case "RD":
      return (
        <span >
          {isCLIEnabled ? (
            <span style={{ color: color || "#FF2D78" }}>Delivery Airline</span>
          ) : (
            <>
              <span style={{ color: color || "#FF2D78" }}>Recovery</span> &{" "}
              <span style={{ color: color || "#11A16E" }}>Delivery</span>
            </>
          )}
        </span>
      );
    case "RT":
      return (
        <span >
          <span style={{ color: color || "#FF2D78" }}>Recovery</span> &{" "}
          <span style={{ color: color || "#CC9506" }}>Transfer</span>
        </span>
      );
    case "OBT":
      return (
        <span  style={{ color: color || "#CC9506" }}>
          {isCLIEnabled ? "P/U" : "Outbound Transfer"}
        </span>
      );
    case "CDK":
      return (
        <span style={{ color: color || "#CC9506" }}>
          Cross Dock
        </span>
      );
    case "WO":
      return (
        <span  style={{ color: color || "#CC9506" }}>
          {I18n.t('general.warehouse')} Storage
        </span>
      );
    case "PCDK":
      return (
        <span >
          <span style={{ color: color || "#FF2D78" }}>Pickup </span> &{" "}
          <span style={{ color: color || "#CC9506" }}>Cross Dock</span>
        </span>
      );
    case "CDKD":
      return (
        <span >
          <span style={{ color: color || "#CC9506" }}>Cross Dock</span> &{" "}
          <span style={{ color: color || "#11A16E" }}>Delivery</span>
        </span>
      );
    case "LH":
      return (
        <span  style={{ color: color || "#CC9506" }}>
          Linehaul (legacy)
        </span>
      );
    case "NLH":
      return (
        <span  style={{ color: color || "#CC9506" }}>
          {orgCode == "MWE" ? "Terminal To Terminal" : "Linehaul"}
        </span>
      );
    case "MS":
      return (
        <span  style={{ color: color || "#617AD6" }}>
          Multi-Stop
        </span>
      );
    case "PLH":
      return (
        <span style={{ color: color || "#FF2D78" }}>{orgCode == "MWE" ? "Door To Terminal" : "Pickup & Linehaul"}</span>
      );
    case "LHD":
      return (
        <span style={{ color: color || "#11A16E" }}>{orgCode == "MWE" ? "Terminal To Door" : "Linehaul & Delivery"}</span>
      );
    case "PLHD":
      return (
        <span style={{ color: color || "#586FCC" }}>
          {orgCode == "SSF" ? "Line Haul" : orgCode == "MWE" ? "Door To Door" : "Pickup,Linehaul & Delivery"}
        </span>
      );
    case "OS":
      return (
        <span style={{ color: color || "#586FCC" }}>On-Site Service</span>
      );
    case "APAD":
      return (
        <span style={{ color: color || "#586FCC" }}>Airport to Airport</span>
      );
    default:
      return <span >{label}</span>;
  }
};

const getLabelDescriptionForLocation = (labelCode, orderLabel = null) => {
  if(!labelCode) return ''
  switch (labelCode) {
    case "R": // Pickup
      return orderLabel === "AFW" ? "Recovery" : `Pickup ${orderLabel == "APAD" ? " (From Airport)" : ""}`;

    case "D": // Delivery
      return orderLabel === "AFW" ? "Transfer" : `Delivery ${orderLabel == "APAD" ? " (To Airport)" : ""}`;

    case "REC": // Recovery
      return "Recovery";

    case "TRANS": // Transfer
      return "Transfer";
    
    case "M": // Move
      return "Move";
    
    case "SDR": // Single Day Pickup
      return "Pickup";
    
    case "SDD": // Single Day Delivery
      return "Delivery";
    
    case "MDR": // Multi Day Pickup 
      return "Pickup";
    
    case "MDD": // Multi Day Delivery
      return "Delivery";

    case "DRPF": // Dropoff
      return "Dropoff";

    case "CDK": // Cross Dock
      return "Cross Dock";

    case "ORN": // Origin
      return "Origin";

    case "DST": // Destination
      return "Destination";

    default:
      return labelCode; // Return the label code if no match
  }
};


const renderOrderTypeIconWithLabel = (orderTypes, type, props, isCLIEnabled = false) => {
  const code = getOrderTypeCode(type);
  let label;
  if (code == "APAD") {
    label = _.find(orderTypes, { extraCode: code })?.label || "";
  } else {
    label = _.find(orderTypes, { code: code })?.label || "";
  }
  if (isCLIEnabled) {
    if (code === 'RD') label = 'Delivery Airline';
    else if (code === 'OBT') label = 'P/U';
  }
  const formattedLabel = label.charAt(0).toUpperCase();
  switch (code) {
    case "R":
      return (
        <Fragment>
          <Icon component={() => <PickupIcon {...props} />} {...props} />
          &nbsp; {label}
        </Fragment>
      );
    case "D":
      return (
        <Fragment>
          <Icon component={() => <DeliveryIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "OR":
      return (
        <Fragment>
          <Icon component={() => <PickupIcon {...props} />} {...props} />
          &nbsp; {label}
        </Fragment>
      );
    case "OD":
      return (
        <Fragment>
          <Icon component={() => <DeliveryIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "M":
      return (
        <Fragment>
          <Icon component={() => <MoveOrderIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "SDR":
      return (
        <Fragment>
          <Icon component={() => <SameDay {...props} />} {...props} />
          &nbsp;Single Day Pickup 
        </Fragment>
      );
    case "MDR":
      return (
        <Fragment>
          <Icon component={() => <MultiDayPickupIcon {...props} />} {...props} />
          &nbsp;Multi Day Pickup 
        </Fragment>
      );
    case "SDD":
      return (
        <Fragment>
          <Icon component={() => <SameDay {...props} />} {...props} />
          &nbsp;Single Day Delivery 
        </Fragment>
      );
    case "MDD":
      return (
        <Fragment>
          <Icon component={() => <MultiDayDeliveryIcon {...props} />} {...props} />
          &nbsp;Multi Day Delivery 
        </Fragment>
      );
    case "T":
      return (
        <Fragment>
          <Icon
            component={() => <PickupDeliveryIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "B":
      return (
        <Fragment>
          <Icon
            component={() => <BeyondIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "E":
      return (
        <Fragment>
          <Icon
            component={() => <ExclusiveIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "H":
      return (
        <Fragment>
          <Icon
            component={() => <HotshotIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "AFW":
      return (
        <Fragment>
          <Icon
            component={() => <RecoveryAndTransferIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "LH":
      return (
        <Fragment>
          <Icon component={() => <LineHaulIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "RD":
      return (
        <Fragment>
          <Icon
            component={() => <RecoveryAndDeliveryIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "RT":
      return (
        <Fragment>
          <Icon
            component={() => <RecoveryAndTransferIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "OBT":
      return (
        <Fragment>
          <Icon
            component={() => <OutboundTransferIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "CDK":
      return (
        <Fragment>
          <Icon component={() => <CrossDockIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "WO":
      return (
        <Fragment>
          <Icon component={() => <WarehouseStorageIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "PCDK":
      return (
        <Fragment>
          <Icon
            component={() => <CrossDockIconPickupIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "CDKD":
      return (
        <Fragment>
          <Icon
            component={() => <CrossDockDeliveryIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    case "MS":
      return (
        <Fragment>
          <Icon component={() => <MultiStopIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "RO":
      return (
        <Fragment>
          <Icon component={() => <CrossDockIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "PLH":
      return (
        <Fragment>
          <Icon component={() => <PickupLinehaulIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "LHD":
      return (
        <Fragment>
          <Icon component={() => <LinehaulDeliveryIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "PLHD":
      return (
        <Fragment>
          <Icon component={() => <TransferLinehaulIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "NLH":
      return (
        <Fragment>
          <Icon component={() => <NewLinehaulIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "OS":
      return (
        <Fragment>
          <Icon component={() => <OnSiteServiceIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
    case "APAD":
      return (
        <Fragment>
          <Icon
            component={() => <PickupDeliveryIcon {...props} />}
            {...props}
          />
          &nbsp;{label}
        </Fragment>
      );
    default:
      return (
        <Fragment>
          <Icon component={() => <PickupIcon {...props} />} {...props} />
          &nbsp;{label}
        </Fragment>
      );
  }
};

const renderNotification = (message, type, duration = 5000) => {
  // return <Snackbar>Hrllo</Snackbar>
  const key = randomNumber();
  if (type === "success") {
    const key = randomNumber();
    notification.open({
      message: (
        <Row className="custom-notification" type="flex">
          <Col
            className="notification-successIcon"
            style={{ width: 40, height: 60 }}
          >
            <AssignIcon style={{ fontSize: 24 }} color="#FFFFFF" />
          </Col>
          <Col className="notification-content">{message}</Col>
        </Row>
      ),
      duration: 0, // Make it persistent
      className: "custom-notification-wrapper ",
      placement: "bottomLeft",
      key,
    });
    setTimeout(() => notification.close(key), duration);
  } else if (type === "error") {
    const stableKey = typeof message === 'string' && message.trim().length > 0
      ? `error_${message}`
      : 'Please fill all required fields';
    notification.close(stableKey);
    notification.open({
      message: (
        <Row
          className="custom-notification"
          type="flex"
          style={{ alignItems: "stretch", minHeight: 60 }}
        >
          <Col className="notification-errorIcon" style={{ width: 40 }}>
            <Icon style={{ fontSize: 24, color: "white" }} type="warning" />
          </Col>
          <Col className="notification-content blkCenterLeft">{message}</Col>
        </Row>
      ),
      duration: 5, // Make it persistent
      className: "custom-notification-wrapper",
      placement: "bottomLeft",
      key: stableKey,
    });
    //setTimeout(() => notification.close(key), duration);
  }
};

const renderOrderCreationNotification = (
  label,
  order_id,
  type,
  duration = 5000,
  type_of_order = "",
  related_order_id = "",
  screenMode = "create", //create or full_edit
) => {
  // return <Snackbar>Hrllo</Snackbar>
  const key = randomNumber();
  if (type === "success") {
    const key = randomNumber();
    notification.open({
      message: (
        <Row className="notification-tab" type="flex">
          <Col className="order-icon" style={{ width: 35, height: 60 }}>
            {/* <AssignIcon style={{ fontSize: 24 }} color="#FFFFFF" /> */}
            {getOrderTypeIcon(label, { width: 24, height: 24 })}
          </Col>
          <Col className="creation-message">
            <div className="div-one">
              {`Order ${screenMode === "full_edit" ? "Updated" : "Created"}!`}
            </div>
            {type_of_order === "M" ? (
              <div className="div-two">
                {screenMode === "full_edit"
                  ? `Order #${order_id}, #${related_order_id} were updated.`
                  : `Order #${order_id}, #${related_order_id} were created.`}
              </div>
            ) : (
              <div className="div-two">
                {screenMode === "full_edit"
                  ? `Order #${order_id} was updated.`
                  : `Order #${order_id} was created.`}
              </div>
            )}
          </Col>
        </Row>
      ),
      duration: 300000, // Make it persistent
      className: "order-creation-notification",
      placement: "bottomLeft",
      key,
    });
    setTimeout(() => notification.close(key), duration);
  } else if (type === "error") {
    const key = randomNumber();
    notification.open({
      message: (
        <Row
          className="custom-notification"
          type="flex"
          style={{ alignItems: "stretch", minHeight: 60 }}
        >
          <Col className="notification-errorIcon" style={{ width: 40 }}>
            <Icon style={{ fontSize: 24, color: "white" }} type="warning" />
          </Col>
          <Col className="notification-content blkCenterLeft">{message}</Col>
        </Row>
      ),
      duration: 5, // Make it persistent
      className: "custom-notification-wrapper",
      placement: "bottomLeft",
    });
    //setTimeout(() => notification.close(key), duration);
  }
};

export {
  WarehouseStorageIcon,
  OnSiteServiceIcon,
  CrossDockDeliveryIcon,
  CrossDockIcon,
  CrossDockIconPickupIcon,
  DeliveryIcon,
  LineHaulIcon,
  MultiStopIcon,
  OutboundTransferIcon,
  RadioActiveIcon,
  PickupIcon,
  PickupDeliveryIcon,
  RecoveryAndTransferIcon,
  RecoveryAndDeliveryIcon,
  FormTemplateIcon,
  SaveAndSearchIcon,
  getOrderTypeIcon,
  getColorForTitleCreateOrderScreen,
  getLabelDescriptionForLocation,
  getOrderTypeIconForLocation,
  getOrderTypeIconForLocationMap,
  showOrderLabelIcon,
  renderOrderTypeIconWithLabel,
  renderNotification,
  renderOrderCreationNotification,
  BeyondIcon,
  ExclusiveIcon,
  HotshotIcon
};
